<template>
  <div>
    <el-form :disabled="readonly" class="section" style="flex-direction: row;">
      <el-checkbox v-model="form.booking" no="booking">{{
        $t('SeaExport.Booking')
      }}</el-checkbox>
      <el-checkbox
        v-model="form.customs"
        no="customs"
        style="margin-left: -20px;"
        @change="val => {(form.customsBroker = val ? form.customsBroker : 0);form.customsDeclarationType=val?form.customsDeclarationType:-1}"
      >{{ $t('SeaExport.CustomsDeclaration') }}
      </el-checkbox>
      <el-checkbox
        v-model="form.signMBL"
        no="signMBL"
        style="margin-left: -20px;"
        @change="pm.isMBLChange()"
      >MB/L
      </el-checkbox>
      <el-checkbox
        v-model="form.signHBL"
        no="signHBL"
        style="margin-left: -20px;"
        :disabled="form.mblOnly"
        @change="pm.isHBLChange()"
      >HB/L
      </el-checkbox>
      <el-checkbox v-model="form.virtualHBL" no="virtualHBL" style="margin-left: -20px;">{{ $t('SeaExport.FormalHbl') }}</el-checkbox>
      <el-checkbox v-model="form.vgm" no="vgm" style="margin-left: -20px;">{{ $t('SeaExport.Vgm') }}</el-checkbox>
      <el-checkbox v-model="form.ams" no="ams" style="margin-left: -20px;">{{ $t('SeaExport.Anti_terrorismShipping') }}</el-checkbox>
      <el-checkbox v-model="form.hds" no="hds" style="margin-left: -20px;">HDS</el-checkbox>
      <el-checkbox v-model="form.comercialInspectation" no="comercialInspectation" style="margin-left: -20px;">{{ $t('SeaExport.CommodityInspection') }}</el-checkbox>
      <el-checkbox v-model="form.heating" no="heating" style="margin-left: -20px;">{{ $t('SeaExport.Fumigation') }}</el-checkbox>
      <el-checkbox v-model="form.itmService" no="itmService" style="margin-left: -20px;">{{ $t('SeaExport.ForeignTrade') }}</el-checkbox>
    </el-form>
    <div style="width: fit-content">
      <div style="display: flex">
        <div class="section form-column">
          <el-form
            :disabled="readonly"
            label-width="130px"
            label-position="right"
          >
            <span class="title">{{ $t('SeaExport.ConsignInfo') }}</span>
            <el-form-item :label="$t('SeaExport.BusinessNo')">
              <el-input :value="form.jobNo" :disabled="true" />
            </el-form-item>
            <el-form-item>
              <span slot="label" class="blue">{{
                $t('SeaExport.ConsignationCompany')
              }}</span>
              <div style="display: flex;align-items: center">
                <el-tooltip
                  v-show="sopImageB"
                  :content="$t('SeaExport.SOPReceiver')"
                  placement="right-end"
                >
                  <img
                    :class="form.customerId && readonly ? '' : 'not-click'"
                    :src="sopPic"
                    width="18"
                    height="28"
                    class="sop-img"
                    style="padding: 5px 0;vertical-align: bottom;cursor: pointer"
                    @click="pm.sopChangeCustomerIdHandler()"
                  >
                </el-tooltip>
                <el-tooltip
                  v-show="showWarningImageB"
                  :content="warningImageBTip"
                  placement="right-end"
                >
                  <i class="el-icon-warning red" style="cursor: pointer" />
                </el-tooltip>
                <cargo-sales-company-select
                  ref="customerSelect"
                  class="shipper-selector"
                  popper-class="shipper-selector-popper"
                  :method-params="{
                    customer: true,
                    companyLob: 'seaExport',
                    active: true
                  }"
                  :check-credit="true"
                  :default-value="form.customerId || ''"
                  :disabled="!customerEnabled"
                  :job="form"
                  style="flex: 1;"
                  @parentCallBack="
                    p => {
                      customerIdChange2ContractHandler(p)
                    }
                  "
                />
              </div>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.CustomerProperty')">
              <el-tooltip :content="customerTip" placement="bottom">
                <span
                  v-show="
                    (contractStatus === 2 &&
                      typeof customerLevel.level === 'number') ||
                      parseInt(customerLevel.level) > -1
                  "
                  class="orange"
                >LV{{ customerLevel.level }}</span>
                <span
                  v-show="
                    (contractStatus === 2 &&
                      typeof customerLevel.level === 'number') ||
                      parseInt(customerLevel.level) > -1
                  "
                  style="color:#D3A73B"
                >&nbsp;{{ customerLevel.customerName }}</span>
                <span
                  v-show="contractStatusLabel"
                  class="red"
                >&nbsp;({{ contractStatusLabel }})</span>
                <span v-show="advancePaymentLabel" style="color:brown">&nbsp;({{ advancePaymentLabel }})</span>
                <span v-show="stampPictureView.businessDocuments.length > 0" @click="stampPictureView.visible = true">
                  <img :title="$t('Message.BookingSeal')" :src="stampIcon" height="14" style="text-align: right;">
                </span>
              </el-tooltip>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.ContactPerson')">
              <div style="display: flex">
                <el-select
                  v-model="form.customerContact"
                  no="customerContact"
                  filterable
                  :allow-create="true"
                >
                  <el-option
                    v-for="(item, index) in contactList"
                    :key="index"
                    :label="item.contactPerson"
                    :value="item.contactPerson"
                  /> </el-select>&nbsp;
                <el-link
                  v-show="!isShowContactPersonDetail"
                  :class="form.customerContact ? '' : 'not-click'"
                  no="customerContactLinek"
                  @click="showContactDialog"
                >{{ $t('SeaExport.Detail') }}
                </el-link>
              </div>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.FLCLType')">
              <el-select
                v-model="form.containerLoadType"
                no="containerLoadType"
                :disabled="!containerLoadTypeEnabled"
                @change="
                  val => {
                    pm.containerLoadTypeChange(val)
                  }
                "
              >
                <el-option
                  v-for="(item, index) in containerLoadTypes"
                  :key="index"
                  :label="isZh ? item.chineseName : item.englishName"
                  :value="item.code"
                />
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.CargoType')">
              <cargo-advance-select
                no="cargoType"
                :select-type="selectTypeNames.basic_data_CargoType"
                :method-params="{ sea: true }"
                filterable
                :clearable="false"
                :default-value="form.cargoType"
                @parentCallBack="
                  p => {
                    form.cargoType = p.value;
                    onCargoTypeChagne()
                  }
                "
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.OrderChannels')">
              <el-input :value="form.salesChannel" :disabled="true" />
            </el-form-item>
            <!--CARGO-18489 新增“渠道单号”字段,显示渠道单号时隐藏委托关联号-->
            <el-form-item v-if="showChannelNo" :label="$t('SeaExport.ChannelNo')">
              <el-input :value="form.channelNo" :disabled="true" />
            </el-form-item>
            <el-form-item>
              <span slot="label" class="blue">{{
                $t('SeaExport.DateOfDeparture2')
              }}</span>
              <div style="display: flex">
                <el-date-picker
                  no="etd"
                  class="departure-date-picker"
                  :value="form.etd"
                  :disabled="(form.lclMasterUuid ? true : !etdEnabled) || !isJydEditJobFields"
                  type="date"
                  value-format="yyyy-MM-dd"
                  style="flex: 1;margin-right: 5px"
                  @input="etdChange"
                />&nbsp;
                <span>{{ form.sailingDay | filterWeek }}</span>
              </div>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.DateOfArrival2')">
              <el-date-picker
                v-model="form.eta"
                no="eta"
                :disabled="!lclslaveEnabled"
                style="width:100%"
                type="date"
                value-format="yyyy-MM-dd"
              />
            </el-form-item>
            <el-form-item>
              <span slot="label">{{ $t('SeaExport.ActualDateOfDeparture2') }}</span>
              <div style="display: flex">
                <el-date-picker
                  :value="form.atd"
                  no="atd"
                  :disabled="!lclslaveEnabled"
                  style="flex: 1;margin-right: 5px"
                  type="date"
                  value-format="yyyy-MM-dd"
                  @input="atdChange"
                />
                <span>{{ form.atdSailingDay|filterWeek }}</span>
              </div>
            </el-form-item>
            <el-form-item>
              <span slot="label">{{ $t('SeaExport.ActualDateOfArrival2') }}</span>
              <div style="display: flex">
                <el-date-picker
                  v-model="form.ata"
                  no="ata"
                  :disabled="!lclslaveEnabled"
                  style="flex: 1;margin-right: 5px"
                  type="date"
                  value-format="yyyy-MM-dd"
                  @input="ataChange"
                />
                <span>{{ form.ataSailingDay|filterWeek }}</span>
              </div>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.OperationDate')">
              <el-date-picker
                v-model="form.customsDate"
                no="customsDate"
                type="date"
                :disabled="!isJydUpdateCustomsDate"
                style="width:100%"
                value-format="yyyy-MM-dd"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.PlaceOfReceiptOnBl')">
              <el-input
                v-model="form.dispatchingPlace"
                no="dispatchingPlace"
                @change="
                  pm.cargoDocChangeHandler()
                  pm.changeDispatchingPlace()
                "
              />
            </el-form-item>
            <el-form-item>
              <span slot="label" class="blue">{{
                $t('SeaExport.PortOfLoading')
              }}</span>
              <div style="display: flex; justify-content: space-between">
                <cargo-advance-select
                  ref="loadingPortCode"
                  no="loadingPortCode"
                  :disabled="!lclslaveEnabled"
                  :select-type="selectTypeNames.basic_data_Seaport"
                  filterable
                  :default-value="form.loadingPortCode"
                  tag-name="englishName"
                  style="flex:1"
                  @parentCallBack="
                    p => {
                      pm.loadingPortCodeChange(p)
                      pm.cargoDocChangeHandler()
                      pm.changeLoadingPort()
                      pm.setPlannerChange()
                    }
                  "
                />&nbsp;
                <el-checkbox
                  v-model="form.transfering"
                  no="transfering"
                  style="padding-left:2px;"
                >{{ $t('SeaExport.Transit') }}</el-checkbox>
              </div>
            </el-form-item>
            <el-form-item
              v-show="form.transfering"
              :label="$t('SeaExport.TransitPort')"
            >
              <cargo-advance-select
                no="transferPortCode"
                :disabled="!lclslaveEnabled"
                :select-type="selectTypeNames.basic_data_Seaport"
                filterable
                :default-value="form.transferPortCode"
                @parentCallBack="
                  p => {
                    form.transferPortCode = p.value
                  }
                "
              />
            </el-form-item>
            <el-form-item>
              <span slot="label" class="blue">{{
                $t('SeaExport.PortOfDischarge')
              }}</span>
              <cargo-advance-select
                no="dischargingPortCode"
                :disabled="!lclslaveEnabled"
                :select-type="selectTypeNames.basic_data_Seaport"
                filterable
                :default-value="form.dischargingPortCode"
                @parentCallBack="
                  p => {
                    pm.dischargingPortCodeChange(p.value, form.carrierId)
                    pm.cargoDocChangeHandler()
                    pm.changeDischargingPort()
                  }
                "
              />
            </el-form-item>
            <el-form-item>
              <span slot="label" class="blue">{{
                $t('SeaExport.PlaceOfDelivery')
              }}</span>
              <cargo-advance-select
                no="destinationPortCode"
                class="port-of-delivery-selector"
                popper-class="port-of-delivery-selector-popper"
                :select-type="selectTypeNames.basic_data_Seaport"
                filterable
                :default-value="form.destinationPortCode"
                @parentCallBack="
                  p => {
                    pm.destinationPortCodeChange(p)
                    pm.cargoDocChangeHandler()
                    pm.changeDestinationPort()
                  }
                "
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.Airline')">
              <el-input :value="pm.vesselLine" :disabled="true" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.FinalDestination')">
              <el-input
                v-model="form.destinationPlace"
                no="destinationPlace"
                @change="
                  pm.cargoDocChangeHandler()
                  pm.changeDestinationPlace()
                "
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.ShippingCompany')">
              <cargo-company-select
                no="carrierId"
                :disabled="!carrierIdEnabled"
                :method-params="{
                  companyLob: 'seaExport',
                  seaCmp: true,
                  active: true
                }"
                :default-value="form.carrierId || ''"
                @change="
                  p => {
                    form.carrierId = p.value
                    pm.carrierChangeHandler(form.dischargingPortCode, p.value)
                  }
                "
                @blur="pm.carrierFocusOutEventHandler()"
              />
            </el-form-item>
            <el-form-item v-if="bookingAgentVisible" :label="$t('SeaExport.BookingAgent')">
              <cargo-advance-select
                v-if="!bookingAgentDataProviderChange"
                no="bookingAgent"
                :select-type="selectTypeNames.basic_data_Company"
                filterable
                :disabled="!bookingAgentEnabled"
                :method-params="{
                  bookingAgent: true,
                  companyLob: 'seaExport',
                  active: true
                }"
                :default-value="form.bookingAgent || ''"
                @parentCallBack="
                  p => {
                    pm.bookingAgentChangeHandler(p)
                  }
                "
              />
              <cargo-advance-select
                v-if="bookingAgentDataProviderChange"
                no="bookingAgent"
                :cache="false"
                :select-type="selectTypeNames.basic_data_Company"
                :disabled="!bookingAgentEnabled"
                :default-value="form.bookingAgent || ''"
                :static-options="pm.bookingAgentArray"
                @parentCallBack="
                  p => {
                    form.bookingAgent = p.value
                    pm.bookingAgentChangeHandler()
                  }
                "
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.CarrierAgent')">
              <cargo-company-select
                no="carrierAgentId"
                :method-params="{
                  seaCmpAgent: true,
                  companyLob: 'seaExport',
                  active: true
                }"
                :default-value="form.carrierAgentId || ''"
                @change="
                  p => {
                    form.carrierAgentId = p.value
                  }
                "
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.SolicitationType')">
              <el-select
                v-model="form.cargoSource"
                no="cargoSource"
                :disabled="!cargoSourceEnabled"
                :placeholder="$t('SeaExport.PleaseSelect')"
                size="mini"
                @change="
                  form.designationAgent = 0
                  pm.cargoSourceChange({ fieldName: 'cargoSource' })
                "
              >
                <el-option
                  v-for="(item, index) in CARGO_SOURCES"
                  :key="index"
                  :label="isZh ? item.chineseName : item.englishName"
                  :value="item.code"
                /> </el-select>&nbsp;
            </el-form-item>
            <el-form-item :label="$t('SeaExport.CustomJobType')">
              <cargo-advance-select
                ref="customJobType"
                no="customJobType"
                :select-type="selectTypeNames.basic_data_CutomJobType"
                filterable
                :default-value="form.customJobType"
                :static-options="customJobTypeList"
                :method-params="{type:form.lob}"
                :tag-name="isZh ? 'name' : 'englishName'"
                @parentCallBack="
                  p => {
                    form.customJobType = p.value;onCustomJobTypeChange();contractRuleFieldChange(form.customerId, form.designationAgent)
                  }
                "
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.PortOfLoadingAgent')">
              <cargo-company-select
                :method-params="{localAgent:true,active: true}"
                :default-value="form.loadingAgentId||''"
                :disabled="readonly"
                no="loadingAgentId"
                :data-filter-function="JobUtils.loadingAgentIdFilter"
                :tag-name="isZh ? 'chineseName' : 'englishName'"
                @change="p=>{form.loadingAgentId = p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('queryJob.destinationAgent')">
              <div style="display: flex;align-items: center">
                <el-tooltip
                  v-show="sopImageC"
                  :content="$t('SeaExport.SOPReceiver')"
                  placement="right-end"
                >
                  <img
                    :class="
                      form.destinationAgent && readonly ? '' : 'not-click'
                    "
                    :src="sopPic"
                    width="18"
                    height="28"
                    class="sop-img"
                    style="padding: 5px 0;cursor: pointer"
                    @click="pm.sopChangeHandler()"
                  >
                </el-tooltip>
                <el-tooltip
                  v-show="showWarningImageC"
                  :content="warningImageCTip"
                  placement="right-end"
                >
                  <i class="el-icon-warning red" style="cursor: pointer" />
                </el-tooltip>
                <cargo-advance-select
                  no="destinationAgent"
                  :select-type="selectTypeNames.basic_data_Company"
                  :disabled="!lclslaveEnabled"
                  :method-params="{
                    overseaAgent: true,
                    companyLob: 'seaExport',
                    active: true
                  }"
                  :default-value="form.destinationAgent || ''"
                  filterable
                  :headers="[$t('Partners.englishName')]"
                  :fields="['englishName']"
                  tag-name="englishName"
                  @parentCallBack="
                    p => {
                      pm.txtDestinationAgentChangeHandler(p)
                    }
                  "
                />
                <cargo-advance-select
                  v-if="overseaAgentDataProviderChange"
                  no="destinationAgent2"
                  :select-type="selectTypeNames.basic_data_Company"
                  :cache="false"
                  :disabled="!lclslaveEnabled"
                  :default-value="form.destinationAgent || ''"
                  filterable
                  :check-credit="true"
                  :headers="[$t('Partners.englishName')]"
                  :fields="['englishName']"
                  tag-name="englishName"
                  :static-options="pm.destinationAgentArray"
                  @parentCallBack="
                    p => {
                      pm.txtDestinationAgentChangeHandler(p)
                    }
                  "
                />
              </div>
            </el-form-item>
            <el-form-item
              v-show="form.cargoSource === 'NC'"
              :label="$t('SeaExport.NominatedAgent')"
            >
              <div style="display: flex;align-items: center">
                <el-tooltip
                  v-show="sopImageA"
                  :content="$t('SeaExport.SOPReceiver')"
                  placement="right-end"
                >
                  <div>
                    <img
                      :class="
                        form.designationAgent && readonly ? '' : 'not-click'
                      "
                      :src="sopPic"
                      width="18"
                      height="28"
                      class="sop-img"
                      style="padding: 5px 0;cursor: pointer"
                      @click="pm.sopChangeBookingAgentHandler()"
                    >
                  </div>
                </el-tooltip>
                <el-tooltip
                  v-show="showWarningImageA"
                  :content="warningImageATip"
                  placement="right-end"
                >
                  <i class="el-icon-warning red" style="cursor: pointer" />
                </el-tooltip>
                <cargo-advance-select
                  no="designationAgent"
                  class="designation-agent-selector"
                  popper-class="designation-agent-selector-popper"
                  :select-type="selectTypeNames.basic_data_Company"
                  :disabled="!designationAgentEnabled"
                  :method-params="{ designationAgent: true, active: true }"
                  :check-credit="true"
                  :default-value="form.designationAgent || ''"
                  filterable
                  :headers="[$t('Partners.englishName')]"
                  :fields="['englishName']"
                  tag-name="englishName"
                  @parentCallBack="
                    p => {
                      pm.designationAgentChangeHandler(p)
                    }
                  "
                />
                <cargo-advance-select
                  v-if="overseaAgentDataProviderChange"
                  no="designationAgent2"
                  :select-type="selectTypeNames.basic_data_Company"
                  :cache="false"
                  :disabled="!designationAgentEnabled"
                  :check-credit="true"
                  :default-value="form.designationAgent || ''"
                  filterable
                  :headers="[$t('Partners.englishName')]"
                  :fields="['englishName']"
                  tag-name="englishName"
                  :static-options="pm.designationAgentArray"
                  @parentCallBack="
                    p => {
                      pm.designationAgentChangeHandler(p)
                    }
                  "
                />
              </div>
            </el-form-item>
          </el-form>
        </div>
        <div class="section form-column" style="width: 400px;">
          <el-form
            :disabled="readonly"
            label-width="140px"
            label-position="right"
          >
            <span class="title">{{
              $t('SeaExport.AdditionalInformation')
            }}</span>
            <el-form-item :label="$t('SeaExport.LocalService')">
              <el-checkbox
                v-model="form.warehousing"
                no="warehousing"
                @change="pm.loadingTermChange('warehousing')"
              >{{ $t('SeaExport.WarehouseLoadingStorage') }}
              </el-checkbox>
              <el-checkbox
                v-model="form.landTransportation"
                no="landTransportation"
                @change="pm.loadingTermChange('landTransportation')"
              >{{ $t('SeaExport.DoorLoadingDelivery') }}
              </el-checkbox>
              <el-checkbox
                v-model="form.selfDeliver"
                no="selfDeliver"
              >{{ $t('SeaExport.NotResponsibleForTruckingAndLoading') }}
              </el-checkbox>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.WarehouseNo')">
              <el-input
                v-model="form.warehouseNo"
                no="warehouseNo"
                style="margin-bottom: 10px;"
                :disabled="!pm.warehouseNoeditable"
              />
              <el-button
                no="warehouseNoBtn"
                :disabled="!(isEdit && isHbl)"
                type="primary"
                style="padding-left:13px;padding-right:13px;"
                @click="pm.clickWarehouseNoHandler()"
              >{{ $t('SeaExport.ObtainTheWarehouseNo') }}
              </el-button>
              <!--此功能屏蔽-->
              <!--<cargo-button-container :disabled="form.jobState!==0" @click="pm.autoAllocateExternalHandler()">
                <el-button
                  type="primary"
                  style="padding-left:13px;padding-right:13px;"
                >{{ $t('SeaExport.AutoDistribution') }}</el-button>
              </cargo-button-container>-->
            </el-form-item>
            <el-form-item :label="$t('SeaExport.MblNo3')">
              <el-input
                :disabled="true"
                :value="form.lclMaster ? form.lclMaster.jobNo : ''"
              />
            </el-form-item>
            <el-form-item
              id="customerRefNo"
              :label="$t('SeaExport.BusinessReferenceNo')"
            >
              <el-tooltip
                :disabled="!customerRefNoTip"
                :content="customerRefNoTip"
                placement="right-end"
              >
                <el-input
                  v-model="form.customerRefNo"
                  no="customerRefNo"
                  :class="customerRefNoTip ? 'red' : ''"
                  @blur="pm.customerRefNoFocusOutHandler()"
                />
              </el-tooltip>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.ItemNo')" :class="poNoRed?'poNoClass':''">
              <el-input v-if="!openProjectConfig" v-model="form.poNo" no="poNo" />
              <cargo-project-select
                v-if="openProjectConfig"
                no="poNo"
                :default-value="form.poNo"
                @change="
                  p => {
                    form.poNo = p.value
                    form.projectName = p.projectName
                  }
                "
              />
            </el-form-item>
            <el-form-item
              v-if="openProjectConfig"
              :label="$t('SeaExport.ProjectName')"
            >
              <el-input :value="form.projectName" />
            </el-form-item>
            <el-form-item
              v-if="openProjectConfig"
              :label="$t('SeaExport.ProjectBatch')"
            >
              <el-input v-model="form.projectBatch" no="projectBatch" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.CustomsBroker')">
              <cargo-advance-select
                no="customsBroker"
                :disabled="!customsBrokerEnabled"
                :select-type="selectTypeNames.basic_data_Company"
                :data-filter-function="customsBrokerFilter"
                filterable
                :default-value="form.customsBroker || ''"
                :placeholder="
                  !customsBrokerEnabled
                    ? $t('SeaExport.PleaseTickCustomsDeclarationOption')
                    : $t('CargoMsg.Cargo_keyWordsTip')
                "
                :method-params="{
                  customsBroker: true,
                  companyLob: 'seaExport',
                  active: true
                }"
                @parentCallBack="
                  p => {
                    form.customsBroker = p.value
                  }
                "
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.CustomsDeclarationType')">
              <cargo-advance-select
                no="customsDeclarationType"
                :disabled="!customsBrokerEnabled"
                :select-type="selectTypeNames.basic_data_CustomsDeclarationType"
                filterable
                :default-value="form.customsDeclarationType===-1?'':form.customsDeclarationType"
                :placeholder="$t('CargoMsg.Cargo_keyWordsTip')"
                @parentCallBack="p=>{form.customsDeclarationType=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.TradeMethod')">
              <cargo-advance-select
                no="tradeTerm"
                :select-type="selectTypeNames.basic_data_TradeTerm"
                filterable
                :default-value="form.tradeTerm"
                @parentCallBack="
                  p => {
                    form.tradeTerm = p.value
                  }
                "
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.HaulageCompany')">
              <cargo-company-select
                no="carryingCmp"
                :disabled="!form.landTransportation"
                :method-params="{ truckCmp: true, active: true }"
                :default-value="form.carryingCmp || ''"
                :placeholder="
                  !form.landTransportation
                    ? $t('SeaExport.PleaseTickDoorLoadingDeliveryOption')
                    : $t('CargoMsg.Cargo_keyWordsTip')
                "
                @change="
                  p => {
                    pm.carryingCmpChangeHandler(p)
                  }
                "
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.Warehouse')">
              <cargo-company-select
                no="warehouseCmp"
                :disabled="!warehouseEabled"
                :method-params="{ warehouse: true, active: true }"
                :default-value="form.warehouseCmp || ''"
                :placeholder="
                  !warehouseEabled
                    ? $t('SeaExport.PleaseSelectWarehouse')
                    : $t('CargoMsg.Cargo_keyWordsTip')
                "
                @change="
                  p => {
                    pm.warehouseCmpChangeHandler(p)
                  }
                "
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.MBLTransportationClause')">
              <cargo-advance-select
                no="freightTerm"
                :select-type="selectTypeNames.basic_data_ShippingTerm"
                filterable
                :clearable="false"
                :default-value="form.freightTerm"
                @parentCallBack="
                  p => {
                    form.freightTerm = p.value
                  }
                "
              />
            </el-form-item>
            <el-form-item
              v-show="!form.mblOnly"
              :label="$t('SeaExport.HBLTransportationClause')"
            >
              <cargo-advance-select
                no="freightTermHBL"
                :select-type="selectTypeNames.basic_data_ShippingTerm"
                filterable
                :clearable="false"
                :default-value="form.freightTermHBL"
                @parentCallBack="
                  p => {
                    form.freightTermHBL = p.value
                    pm.freightTermHBLChange()
                  }
                "
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.MasterBLFreightTerm')">
              <cargo-advance-select
                no="paymentTermMBL"
                :disabled="!lclslaveEnabled"
                :select-type="selectTypeNames.basic_data_PaymentTerm"
                filterable
                :clearable="false"
                :default-value="form.paymentTermMBL"
                @parentCallBack="
                  p => {
                    form.paymentTermMBL = p.value
                    pm.paymentTermMBLChange()
                  }
                "
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.PlaceOfMblPayment')">
              <el-input
                v-show="!pm.isShowAcPaymentPlaceBL"
                v-model="mblDoc.paymentPlaceBL"
                no="paymentPlaceBL"
                :disabled="
                  !(
                    isEdit &&
                    (form.paymentTermMBL === '3P' ||
                    form.paymentTermMBL === 'PP')
                  )
                "
                @change="pm.fieldChangeHandler()"
              />
              <cargo-advance-select
                v-if="pm.isShowAcPaymentPlaceBL"
                no="paymentPlaceBL"
                :select-type="selectTypeNames.basic_data_Seaport"
                filterable
                :default-value="mblDoc.paymentPlaceBL || ''"
                @parentCallBack="
                  p => {
                    mblDoc.paymentPlaceBL = p.value
                  }
                "
              />
            </el-form-item>
            <el-form-item
              v-show="!form.mblOnly"
              :label="$t('SeaExport.HBLFreightClause')"
            >
              <cargo-advance-select
                no="paymentTermHBL"
                :select-type="selectTypeNames.basic_data_PaymentTerm"
                filterable
                :clearable="false"
                :default-value="form.paymentTermHBL"
                :allow-create="true"
                @parentCallBack="
                  p => {
                    pm.paymentSelectHblChange(p.value)
                  }
                "
              />
            </el-form-item>
            <el-form-item
              v-show="!form.mblOnly"
              :label="$t('SeaExport.PlaceOfHblPayment')"
            >
              <el-input v-model="hdoc.paymentPlaceBL" no="paymentPlaceBL" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.ContractRateProperty')">
              <el-select
                v-model="form.bookingTerm"
                no="bookingTerm"
                :disabled="!pm.bookingTermEditable"
                :placeholder="readonly ? '' : $t('SeaExport.PleaseSelect')"
                :clearable="false"
                size="mini"
                @change="pm.bookingTermChange()"
              >
                <el-option
                  v-for="(item, index) in bookingTerms"
                  :key="index"
                  :label="isZh ? item.chineseName : item.englishName"
                  :value="item.code"
                />
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.TradeTerms2')">
              <cargo-advance-select
                no="incoTerm"
                :select-type="selectTypeNames.basic_data_IncoTerm"
                filterable
                :clearable="false"
                :default-value="form.incoTerm"
                @parentCallBack="
                  p => {
                    form.incoTerm = p.value
                  }
                "
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.CargoSize')">
              <el-input
                v-model="form.measurements"
                no="measurements"
                type="textarea"
                :rows="5"
                @dblclick.native="
                  showAdvanceTextDialog(
                    $t('SeaExport.CargoSize'),
                    form.measurements,
                    val => {
                      form.measurements = val
                    }
                  )
                "
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.SpecialPriceInstructions')">
              <el-input v-model="form.salePriceRemarks" no="salePriceRemarks" />
            </el-form-item>
            <div style="display: flex;justify-content: space-around">
              <el-checkbox
                v-model="form.mblOnly"
                no="mblOnly"
                style="margin: 0"
                @change="pm.isMblOnlyChange()"
              >{{ $t('SeaExport.DirectBusiness') }}
              </el-checkbox>
              <el-checkbox
                v-model="form.transfering"
                no="transfering"
                :disabled="!lclslaveEnabled"
                style="margin: 0"
              >{{ $t('SeaExport.Transport') }}
              </el-checkbox>
              <el-checkbox
                v-model="form.batch"
                no="batch"
                :disabled="!lclslaveEnabled"
                style="margin: 0"
              >{{ $t('SeaExport.InBatches') }}
              </el-checkbox>
              <el-checkbox v-model="form.salePrice" no="salePrice">{{
                $t('SeaExport.SpecialPrice')
              }}</el-checkbox>
            </div>
            <!-- 隐藏免柜租期 免堆天数 关区申请 代码撤回-->
            <el-form-item :label="$t('SeaExport.FreeDemurrage')">
              <el-input v-model="form.freeDemurrage" no="freeDemurrage" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.FreeDetention')">
              <el-input v-model="form.freeDetention" no="freeDetention" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.CustomsAreaApplication')">
              <el-input v-model="form.customsAreaApplication" no="customsAreaApplication" />
            </el-form-item>
          </el-form>
        </div>
        <div class="section form-column form-item-label">
          <el-form
            :disabled="readonly"
            label-width="145px"
            label-position="right"
          >
            <span class="title">{{ $t('SeaExport.ContainerInfo2') }}</span>
            <booking-sea-eq-data-grid
              ref="bookingSeaEqDataGrid"
              no="bookingSeaEqDataGrid"
              :value="seaEqList"
              :container-load-type="form.containerLoadType"
              :is-edit="isEdit"
              :job="form"
            />
            <el-form-item :label="$t('SeaExport.QuantityConsignActual')">
              <div style="display: flex">
                <auto-number-input
                  v-model="form.quantityContract"
                  no="quantityContract"
                  :precision="0"
                  :min="0"
                  :disabled="!isJydEditJobFields"
                  @change="pm.jobContractQwcChange(1)"
                />
                <span style="padding:0 2px;">/</span>
                <auto-number-input
                  ref="quantityActual"
                  v-model="form.quantityActual"
                  no="quantityActual"
                  :precision="0"
                  :min="0"
                  :disabled="pm.billChargeFlag || !isJydEditJobFields"
                  @change="
                    SEUtils.changeQWCRule(null, () => {
                      form.quantityContract = form.quantityActual
                    })
                    pm.changeSynBillOfLadingQWC()
                    pm.txtPackingChangeHandler()
                    pm.refContainerUsageQwc(2)
                  "
                />
                <span>PCS</span>
              </div>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.WeightConsignActual')">
              <div style="display: flex">
                <auto-number-input
                  v-model="form.weightContract"
                  no="weightContract"
                  :precision="3"
                  :min="0"
                  :disabled="!isJydEditJobFields"
                  @change="pm.jobContractQwcChange(2)"
                />
                <span style="padding:0 2px;">/</span>
                <auto-number-input
                  ref="weightActual"
                  v-model="form.weightActual"
                  no="weightActual"
                  :precision="3"
                  :min="0"
                  :disabled="pm.billChargeFlag || !isJydEditJobFields"
                  @change="
                    SEUtils.changeQWCRule(null, () => {
                      form.weightContract = form.weightActual
                    })
                    pm.calculateChargeWeight()
                    pm.refContainerUsageQwc(2)
                  "
                />
                <span>KGS</span>
              </div>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.CubageConsignActual')">
              <div style="display: flex">
                <auto-number-input
                  v-model="form.cubageContract"
                  no="cubageContract"
                  :precision="3"
                  :min="0"
                  :disabled="!isJydEditJobFields"
                  @change="pm.jobContractQwcChange(3)"
                />
                <span style="padding:0 2px;">/</span>
                <auto-number-input
                  ref="cubageActual"
                  v-model="form.cubageActual"
                  no="cubageActual"
                  :precision="3"
                  :disabled="!cubageActualEnabled || !isJydEditJobFields"
                  :min="0"
                  @change="
                    SEUtils.changeQWCRule(null, () => {
                      form.cubageContract = form.cubageActual
                      form.chargeWeight = form.cubageActual
                    })
                    pm.calculateChargeWeight()
                    pm.refContainerUsageQwc(2, false)
                  "
                />
                <span>CBM</span>
              </div>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.Package')">
              <cargo-packing-select
                :default-value="form.packing"
                no="packing"
                @change="
                  p => {
                    form.packing = p.value
                    pm.txtPackingChangeHandler()
                  }
                "
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.Pieces')">
              <auto-number-input
                v-model="form.insideQuantity"
                no="insideQuantity"
                :precision="0"
                :min="0"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.PiecesType')">
              <cargo-packing-select
                :default-value="form.insidePacking"
                no="insidePacking"
                @change="
                  p => {
                    form.insidePacking = p.value
                  }
                "
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.ChargedWeightRT')">
              <div style="display: flex">
                <el-input-number
                  :value="form.chargeWeight || undefined"
                  no="chargeWeight"
                  :precision="3"
                  :controls="false"
                  style="flex:1"
                  :disabled="!chargeWeightEnabled"
                  :min="0"
                  @input="
                    val => {
                      form.chargeWeight = val
                    }
                  "
                  @change="pm.changeSynBillOfLadingQWC()"
                />
                <span>M/T</span>
              </div>
            </el-form-item>
            <el-form-item v-show="isEdit">
              <div slot="label">
                <el-button
                  type="primary"
                  no="Copy2"
                  @click="transcribeDialog.visible = true"
                >{{ $t('SeaExport.Copy2') }}
                </el-button>
              </div>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.EnglishDescriptionOfGoods')">
              <cargo-rich-textarea
                ref="cargoTextarea1"
                v-model="form.cargoEnglishName"
                no="cargoEnglishName"
                :text-chars="0"
                :warning-count="-1"
                :disabled="!isEdit"
                wrap-symbol="r"
                style="height: 110px"
                :auto-uppercase="isUppercaseByConfig"
                @change="onCargoEnglishNameChange"
                @dblclick.native="
                  showAdvanceTextDialog(
                    $t('SeaExport.EnglishDescriptionOfGoods'),
                    form.cargoEnglishName,
                    val => {
                      form.cargoEnglishName = val
                    },isUppercaseByConfig, {autoUppercase:isUppercaseByConfig}
                  )
                "
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.Marks')">
              <cargo-rich-textarea
                ref="cargoTextarea2"
                v-model="form.mark"
                no="mark"
                :text-chars="0"
                :warning-count="-1"
                wrap-symbol="r"
                :disabled="!isEdit"
                style="height: 110px"
                :auto-uppercase="isUppercaseByConfig"
                @change="onMarkChange"
                @dblclick.native="
                  showAdvanceTextDialog(
                    $t('SeaExport.Marks'),
                    form.mark,
                    val => {
                      form.mark = val
                    },isUppercaseByConfig, {autoUppercase:isUppercaseByConfig}
                  )
                "
              />
            </el-form-item>
            <el-form-item>
              <div slot="label">
                <span>{{ $t('SeaExport.HsCode') }}</span>
                <br>
                <el-button
                  v-show="isEdit"
                  no="HsCodeBtn"
                  type="primary"
                  @click="
                    showHsCodeSearchDialog(
                      $t('Message.SelectHsCode'),
                      p => (form.hsCode = p.code)
                    )
                  "
                >{{ $t('SeaExport.Search') }}
                </el-button>
              </div>
              <el-input
                v-model="form.hsCode"
                no="hsCode"
                type="textarea"
                :rows="5"
                @dblclick.native="
                  showAdvanceTextDialog(
                    $t('SeaExport.HsCode'),
                    form.hsCode,
                    val => {
                      form.hsCode = val
                    }
                  )
                "
              />
            </el-form-item>
            <el-form-item>
              <div slot="label">
                <span>{{ $t('SeaExport.ChineseDescriptionOfGoods') }}</span>
                <br>
                <el-button
                  v-show="isEdit"
                  no="cargoChineseNameBtn"
                  type="primary"
                  @click="
                    showHsCodeSearchDialog(
                      $t('Message.SelectCargoChineseName'),
                      p => (form.cargoChineseName = p.commodityName)
                    )
                  "
                >{{ $t('SeaExport.Search') }}
                </el-button>
              </div>
              <cargo-rich-textarea
                v-model="form.cargoChineseName"
                no="cargoChineseName"
                :disabled="!isEdit"
                :auto-uppercase="false"
                style="height: 110px"
                @dblclick.native="
                  showAdvanceTextDialog(
                    $t('SeaExport.ChineseDescriptionOfGoods'),
                    form.cargoChineseName,
                    val => {
                      form.cargoChineseName = val
                    }
                  )
                "
              />
            </el-form-item>
            <el-form-item
              :label="$t('SeaExport.CategoryOfGoods')"
              class="custom"
            >
              <cargo-advance-select
                :select-type="selectTypeNames.basic_data_CargoInformation"
                :disabled="readonly"
                no="cargoCode"
                filterable
                :clearable="true"
                :default-value="form.cargoCode"
                :allow-create="false"
                @parentCallBack="
                  p => {
                    pm.cargoCodeChange(p.value)
                  }
                "
              />
            </el-form-item>
            <el-form-item>
              <el-input
                v-model="form.cargoName"
                no="cargoName"
                :disabled="
                  !(isEdit && form.cargoCode != '' && form.cargoCode != null)
                "
              />
            </el-form-item>
          </el-form>
        </div>
        <div class="section form-column">
          <el-form
            :disabled="readonly"
            label-width="135px"
            label-position="right"
          >
            <span class="title">{{ $t('SeaExport.OperationInfo') }}</span>
            <el-form-item>
              <span slot="label" class="blue">{{
                $t('SeaExport.SalesCompany')
              }}</span>
              <el-input :value="txtSalesOffice" :disabled="true" />
            </el-form-item>
            <el-form-item>
              <span slot="label" class="blue">{{ $t('SeaExport.Sales') }}</span>
              <div style="display: flex;justify-content: space-between">
                <cargo-user-select
                  ref="sales"
                  :disabled="!saleEnabled"
                  no="sales"
                  :method-params="{
                    officeId: salesOfficeCheck
                      ? $store.getters.currentOfficeId
                      : '',
                    category: 'role',
                    shape: 'sales'
                  }"
                  :default-value="form.sales || ''"
                  :static-options="salesList"
                  :placeholder="salesPrompt"
                  style="flex: 1"
                  @change="
                    p => {
                      form.salesRecord = p.value
                      pm.salesChangeHandler(p)
                    }
                  "
                />&nbsp;
                <el-checkbox
                  v-model="form.provisioned"
                  no="provisioned"
                  style="margin-left: 5px"
                  :disabled="true"
                >{{ $t('SeaExport.Accrued') }}
                </el-checkbox>
              </div>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.SalesOfGoods')">
              <cargo-user-select
                no="cargoSalesId"
                :method-params="{ category: 'role', shape: 'salesOfGoods' }"
                :default-value="form.cargoSalesId || ''"
                :static-options="cargoSalesList"
                @change="
                  p => {
                    form.cargoSalesId = p.value;pm.cargoSalesChargeHandler(p)
                  }
                "
              />
            </el-form-item>
            <el-form-item>
              <span slot="label" class="blue">{{
                $t('SeaExport.SalesDepartment')
              }}</span>
              <cargo-department-new-select
                no="salesDepartment"
                :disabled="!form.sales"
                :sales-id="Number(form.sales)"
                :office-id="form.salesOffice"
                :department-id="Number(form.salesDepartment)"
                @change="
                  p => {form.salesDepartment = p.value
                        pm.departmentChargeHandler()
                  }
                "
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.OperationCompany')">
              <cargo-office-select
                no="opOffice"
                :disabled="(!isRegionalCommission && pm.isEntrustOrder(true)) || opOfficeDisabled"
                :is-regional-commission="isRegionalCommission"
                :office-id="Number(form.opOffice)"
                @change="
                  p => {
                    form.opOffice = p.value
                    form.opDepartment=0
                    pm.opOfficeChangeHandler();contractRuleFieldChange(form.customerId, form.designationAgent)
                  }
                "
              />
            </el-form-item>
            <el-form-item>
              <span slot="label" class="blue">{{
                $t('SeaExport.OperationDepartment')
              }}</span>
              <cargo-department-select
                no="opDepartment"
                :disabled="pm.isWithinCloseAccountDate"
                :office-id="Number(form.opOffice)"
                :department-id="Number(form.opDepartment)"
                @change="
                  p => {
                    form.opDepartment = p.value
                  }
                "
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.Operation')">
              <cargo-user-select
                no="op"
                :disabled="!opEabled"
                :method-params="{
                  officeId: form.opOffice,
                  category: 'role',
                  shape: 'op'
                }"
                :default-value="form.op || ''"
                :static-options="userPortRoleData.op"
                @change="
                  p => {
                    form.op = p.value
                    pm.txtOPChangeHandler(p)
                  }
                "
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.CustomerOffice')">
              <cargo-office-select
                no="csrOffice"
                :disabled="true"
                :office-id="Number(form.csrOffice)"
                @change="p=>{form.csrOffice=p.value;form.csrDepartment=0}"
              />
            </el-form-item>
            <el-form-item>
              <span slot="label">{{ $t('Message.Customer_Service') }}</span>
              <cargo-department-select
                no="csrDepartment"
                :office-id="Number(form.csrOffice)"
                :enables="true"
                :department-id="Number(form.csrDepartment)"
                @change="p=>{form.csrDepartment=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.CustomerService')">
              <cargo-user-select
                ref="csr"
                no="csr"
                :method-params="{
                  officeId:
                    pm.isEntrustOrder || form.salesOffice === 1
                      ? form.opOffice
                      : form.salesOffice,
                  category: 'role',
                  shape: 'csr'
                }"
                :default-value="form.csr || ''"
                :static-options="userPortRoleData.csr"
                @change="
                  p => {
                    pm.csrChangeHandler(p)
                  }
                "
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.FieldOperation')">
              <cargo-user-select
                :method-params="{officeId: form.opOffice,category:'role',shape:'siteOp'}"
                :default-value="form.siteOP||''"
                :static-options="userPortRoleData.siteOp"
                @change="p=>{JobUtils.siteOpChangeHandler(form, p)}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.OverseaCustomerService')">
              <cargo-user-select
                ref="overseaOp"
                no="overseaOp"
                :default-value="form.overseaOp || ''"
                :method-params="{category:'role',shape:'overseaOp'}"
                :static-options="isHC ? null : (userPortRoleData.overseaOp || overseaAgentUsersList)"
                @change="
                  p => {
                    form.overseaOp = p.value
                    pm.overseaOpChangeHandler(p)
                  }
                "
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.DocumentOffice')">
              <cargo-office-select
                no="dcOffice"
                :disabled="true"
                :office-id="Number(form.dcOffice)"
                @change="p=>{form.dcOffice=p.value;form.dcDepartment=0}"
              />
            </el-form-item>
            <el-form-item>
              <span slot="label">{{ $t('Message.Documentation_Department') }}</span>
              <cargo-department-select
                no="dcDepartment"
                :office-id="Number(form.dcOffice)"
                :enables="true"
                :department-id="Number(form.dcDepartment)"
                @change="p=>{form.dcDepartment=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.Documents')">
              <cargo-user-select
                ref="dc"
                no="dc"
                :method-params="{
                  officeId: form.opOffice,
                  category: 'role',
                  shape: 'doc'
                }"
                :default-value="form.dc || ''"
                :static-options="userPortRoleData.doc"
                @change="
                  p => {
                    pm.dcChangeHandler(p)
                  }
                "
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.AirlineOffice')">
              <cargo-office-select
                no="plannerOffice"
                :disabled="true"
                :office-id="Number(form.plannerOffice)"
                @change="p=>{form.plannerOffice=p.value;form.plannerDepartment=0}"
              />
            </el-form-item>
            <el-form-item>
              <span slot="label">{{ $t('SeaExport.AirlineDepartment') }}</span>
              <cargo-department-select
                no="plannerDepartment"
                :office-id="Number(form.plannerOffice)"
                :enables="true"
                :department-id="Number(form.plannerDepartment)"
                @change="p=>{form.plannerDepartment=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.AirlinePerson2')">
              <cargo-user-select
                no="planner"
                :method-params="{
                  officeId: form.opOffice,
                  category: 'role',
                  shape: 'seaLine'
                }"
                :default-value="form.planner || ''"
                :static-options="userPortRoleData.seaLine"
                @change="
                  p => {
                    form.planner = p.value
                    pm.txtPlannerChangeHandler(p)
                  }
                "
              />
            </el-form-item>
            <special-requests-grid
              ref="selectedSpecialRequest"
              v-model="form.satisfiedRequests"
              no="satisfiedRequests"
              :is-edit="isEdit"
              :customer-id="Number(form.customerId)"
              :lob="form.lob"
              :job="form"
              style="margin-bottom: 5px"
            />
          </el-form>
          <el-form
            :disabled="lockJobByPrintHblZb ? false : readonly"
            label-width="135px"
            label-position="right"
          >
            <el-form-item :label="$t('SeaExport.OperationRequirements')">
              <el-tooltip :content="form.operationContent" placement="left">
                <div
                  slot="content"
                  v-html="
                    form.operationContent
                      ? form.operationContent.replace(/[\n]/g, '</br>')
                      : $t('SeaExport.NoData')
                  "
                />
                <el-input
                  no="operationContent"
                  :value="form.operationContent"
                  :placeholder="readonly ? '' : $t('SeaExport.DoubleClickToAddOperationRequirements')"
                  type="textarea"
                  :rows="4"
                  @dblclick.native="
                    selectOperationReqDialog.value = form.operationContent
                    selectOperationReqDialog.visible = isEdit || lockJobByPrintHblZb
                  "
                />
              </el-tooltip>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.OperationTips')">
              <el-input
                v-model="form.operationTips"
                no="operationTips"
                type="textarea"
                :rows="4"
              />
            </el-form-item>
          </el-form>
          <el-form
            :disabled="readonly"
            label-width="135px"
            label-position="right"
          >
            <el-form-item :label="$t('SeaExport.ExtraChargeClause')">
              <el-input
                :value="txtSurchargeTerms"
                no="txtSurchargeTerms"
                :placeholder="readonly? '' : $t('SeaExport.DoubleClickToAddExtraChargeClause')"
                type="textarea"
                :rows="4"
                @dblclick.native="
                  selectSurchargeTermsDialog.rowData = form.surchargeTerms
                  selectSurchargeTermsDialog.visible = true
                "
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.WarehousingInfo')">
              <el-input
                :disabled="true"
                type="textarea"
                :rows="4"
                :value="txtWhs"
              />
            </el-form-item>
          </el-form>
          <el-form
            :disabled="lockJobByPrintHblZb ? false : readonly"
            label-width="135px"
            label-position="right"
          >
            <el-form-item :label="$t('SeaExport.Remarks')">
              <el-input
                v-model="form.remarks"
                no="remarks"
                type="textarea"
                :rows="4"
                @dblclick.native="
                  showAdvanceTextDialog(
                    $t('SeaExport.Remarks'),
                    form.remarks,
                    val => {
                      form.remarks = val
                    }
                  )
                "
              />
            </el-form-item>
          </el-form>
        </div>
        <div class="section form-column">
          <el-form
            :disabled="lockJobByPrintHblZb ? false : readonly"
            label-width="100px"
            label-position="right"
          >
            <span class="title">{{ $t('SeaExport.UserDefinedArea') }}</span>
            <el-form-item :label="$t('SeaExport.UserDefinedField1')">
              <el-input
                v-model="form.userDefinedField1"
                no="userDefinedField1"
                type="textarea"
                :rows="5"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.UserDefinedField2')">
              <el-input
                v-model="form.userDefinedField2"
                no="userDefinedField2"
                type="textarea"
                :rows="5"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.UserDefinedField3')">
              <el-input
                v-model="form.userDefinedField3"
                no="userDefinedField3"
                type="textarea"
                :rows="5"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.UserDefinedField4')">
              <el-input
                v-model="form.userDefinedField4"
                no="userDefinedField4"
                type="textarea"
                :rows="5"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.TaxNature')">
              <el-select
                v-model="form.taxNature"
                no="taxNature"
                :placeholder="$t('SeaExport.PleaseSelect')"
                size="mini"
              >
                <el-option
                  v-for="(item,index) in TAX_NATURES"
                  :key="index"
                  :label="isZh?item.chineseName:item.englishName"
                  :value="item.code"
                />
              </el-select>&nbsp;
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="section" style="width:100%">
        <span class="title">{{ $t('SeaExport.CustomerDeliveryInfo') }}</span>
        <div class="form-row" style="display:flex;flex-direction:row;">
          <el-form
            :disabled="readonly"
            label-width="50px"
            label-position="left"
            style="margin-right:10px"
          >
            <el-form-item :label="$t('SeaExport.Shipper')">
              <cargo-company-select
                :method-params="{ shipper: true, active: true }"
                no="shipperId"
                :default-value="form.shipperId || ''"
                style="display: inline-block;width:175px;margin-right: 5px"
                @change="
                  data => {
                    pm.shipperChange(data)
                  }
                "
              />&nbsp;
              <el-button
                type="primary"
                no="billAddressDialogBtn"
                style="vertical-align: top"
                @click="billAddressDialog.visible = true"
              >{{ $t('SeaExport.CodeSearching') }}
              </el-button>
            </el-form-item>
            <el-form-item v-for="i in 7" :key="i" label-width="0">
              <cargo-input
                :ref="'shipperLine' + i"
                v-model="form['shipperLine' + i]"
                :no="'shipperLine' + i"
                :auto-uppercase="notUppercaseShipperConsigneNotify"
                @change="
                  () =>
                    wrapAddr(
                      form,
                      'shipperLine' + i,
                      i + 1 > 6 ? null : 'shipperLine' + (i + 1),
                      200
                    )
                "
                @dblclick.native="
                  showAdvanceTextDialog(
                    $t('SeaExport.Shipper'),
                    mergeShipperLine(),
                    splitShipperLine,
                    notUppercaseShipperConsigneNotify
                  )
                "
              />
            </el-form-item>
          </el-form>
          <el-form
            :disabled="readonly"
            label-width="63px"
            label-position="left"
            style="margin-right:20px"
          >
            <el-form-item :label="$t('SeaExport.Consignee')">
              <cargo-company-select
                no="consigneeId"
                :method-params="{ consignee: true, active: true }"
                :default-value="form.consigneeId || ''"
                style="display: inline-block;width:175px;margin-right: 5px"
                @change="
                  data => {
                    pm.consigneeChange(data)
                  }
                "
              />&nbsp;
              <el-button
                no="consigneeIdBtn"
                type="primary"
                style="vertical-align: top"
                @click="billAddressDialog.visible = true"
              >{{ $t('SeaExport.CodeSearching') }}
              </el-button>
            </el-form-item>
            <el-form-item v-for="i in 7" :key="i" label-width="0">
              <cargo-input
                :ref="'consigneeLine' + i"
                v-model="form['consigneeLine' + i]"
                :no="'consigneeLine' + i"
                :auto-uppercase="notUppercaseShipperConsigneNotify"
                @change="
                  () =>
                    wrapAddr(
                      form,
                      'consigneeLine' + i,
                      i + 1 > 6 ? null : 'consigneeLine' + (i + 1),
                      200
                    )
                "
                @dblclick.native="
                  showAdvanceTextDialog(
                    $t('SeaExport.Consignee'),
                    mergeConsigneeLine(),
                    splitConsigneeLine,
                    notUppercaseShipperConsigneNotify
                  )
                "
              />
            </el-form-item>
          </el-form>
          <el-form
            :disabled="readonly"
            label-width="50px"
            label-position="left"
            style="margin-right:20px"
          >
            <el-form-item :label="$t('SeaExport.NotifyParty')">
              <cargo-company-select
                no="notifyId"
                :method-params="{ notify: true, active: true }"
                :default-value="form.notifyId || ''"
                style="display: inline-block;width:175px;margin-right: 5px"
                @change="
                  data => {
                    pm.notifyChange(data)
                  }
                "
              />&nbsp;
              <el-button
                no="notifyIdBtn"
                type="primary"
                style="vertical-align: top"
                @click="billAddressDialog.visible = true"
              >{{ $t('SeaExport.CodeSearching') }}
              </el-button>
            </el-form-item>
            <el-form-item v-for="i in 7" :key="i" label-width="0">
              <cargo-input
                :ref="'notifyLine' + i"
                v-model="form['notifyLine' + i]"
                :no="'notifyLine' + i"
                :auto-uppercase="notUppercaseShipperConsigneNotify"
                @change="
                  () =>
                    wrapAddr(
                      form,
                      'notifyLine' + i,
                      i + 1 > 6 ? null : 'notifyLine' + (i + 1),
                      200
                    )
                "
                @dblclick.native="
                  showAdvanceTextDialog(
                    $t('SeaExport.NotifyParty'),
                    mergeNotifyLine(),
                    splitNotifyLine,
                    notUppercaseShipperConsigneNotify
                  )
                "
              />
            </el-form-item>
          </el-form>
          <div>
            <span
              style="display:inline-block;line-height:28px;padding-bottom: 5px;"
            >{{ $t('SeaExport.SecondNotifyParty') }}</span>
            <cargo-rich-textarea
              v-model="form.alsoNotify"
              no="alsoNotify"
              :disabled="readonly"
              :text-chars="0"
              wrap-symbol="r"
              style="width: 310px;height: 230px;"
              @dblclick.native="
                showAdvanceTextDialog(
                  $t('SeaExport.SecondNotifyParty'),
                  form.alsoNotify,
                  val => {
                    form.alsoNotify = val
                  },
                  notUppercaseShipperConsigneNotify,
                  { warningCount: 45, maxChar: 0 }
                )
              "
            />
          </div>
        </div>
      </div>
      <div class="section" style="width: 100%;">
        <div class="title">
          {{ $t('SeaExport.TicketsInfo') }}
          <div ref="division" class="division" :style="{height:divisionHeight+'px'}" @mousedown="divisionEnabled=true">
            <div class="line" style="margin-top:2px" />
            <div class="line" />
          </div>
        </div>
        <div style="display:flex;flex-direction:column;margin-bottom: 5px;line-height: 28px;">
          <div style="padding:5px 0">
            <span style="margin-right: 5px;">{{ $t('SeaExport.TotalTickets') }}:</span><span style="margin-right: 5px;">{{ form.lclSlaves.length }}</span>
            <div v-show="readonly&&viewSource==='bookingWorkspace'" style="display: inline-flex;">
              <el-button
                :disabled="viewSource === 'financeDetail' || viewSource === 'salesDetail'"
                no="NewTickets"
                type="primary"
                @click="btnCreateClickHandler"
              >{{ $t('SeaExport.NewTickets') }}</el-button>
              <el-button
                :disabled="!selectedRow || viewSource === 'financeDetail' || viewSource === 'salesDetail'"
                no="EditTickets"
                type="primary"
                @click="btnLcLEditClickHandler"
              >{{ $t('SeaExport.EditTickets') }}</el-button>
              <el-button
                :disabled="viewSource === 'financeDetail' || viewSource === 'salesDetail'"
                no="AddTickets"
                type="primary"
                @click="btnImportLclClickHandler"
              >{{ $t('SeaExport.AddTickets') }}</el-button>
              <el-button
                :disabled="!selectedRow || viewSource === 'financeDetail' || viewSource === 'salesDetail'"
                no="RemoveTickets"
                type="danger"
                @click="pm.btnRemoveBatchClickHandler()"
              >{{ $t('SeaExport.RemoveTickets') }}</el-button>
              <el-button
                :disabled="!selectedRow || viewSource === 'financeDetail' || viewSource === 'salesDetail'"
                no="DeleteTickets"
                type="danger"
                @click="btnRemoveClickHandler"
              >{{ $t('SeaExport.DeleteTickets') }}</el-button>
            </div>
          </div>
          <div ref="slaveDiv" style="display: flex;">
            <cargo-ag-grid
              config-module="130135"
              :grid-options="gridOptions"
              :column-defs="columnDefs"
              :row-data="rowData"
              @gridReady="params=>{gridApi=params.api}"
            />
          </div>
        </div>
      </div>
    </div>
    <!-- 联系人弹框 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="contactDialog.visible"
      :title="$t('SeaExport.ContactPerson')"
      width="400px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-form label-position="right" label-width="100px">
        <el-form-item :label="$t('SeaExport.ContactPerson') + '：'">
          <el-input
            :disabled="true"
            :value="contactDialog.data.contactPerson"
            style="width: 170px;"
          />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.Role') + '：'">
          <el-input
            :disabled="true"
            :value="contactDialog.data.role"
            style="width: 170px;"
          />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.Tel') + '：'">
          <el-input
            :disabled="true"
            :value="contactDialog.data.telephone"
            style="width: 170px;"
          />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.Mobile') + '：'">
          <el-input
            :disabled="true"
            :value="contactDialog.data.mobile"
            style="width: 170px;"
          />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.Fax') + '：'">
          <el-input
            :disabled="true"
            :value="contactDialog.data.fax"
            style="width: 170px;"
          />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.Email') + '：'">
          <el-input
            :disabled="true"
            :value="contactDialog.data.email"
            style="width: 170px;"
          />
        </el-form-item>
        <el-form-item :label="$t('CargoMsg.Cargo_Remarks') + '：'">
          <el-input
            :disabled="true"
            :value="contactDialog.data.remarks"
            type="textarea"
            :rows="3"
            style="width: 170px;"
          />
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 高级文本弹框 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="advanceTextDialog.visible"
      :title="advanceTextDialog.title"
      width="600px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <cargo-rich-textarea
        ref="advanceTextDialogTextarea"
        v-model="advanceTextDialog.value"
        :disabled="readonly"
        :text-chars="advanceTextDialog.formatObj.maxChar"
        :warning-count="advanceTextDialog.formatObj.warningCount"
        :auto-uppercase="advanceTextDialog.formatObj.autoUppercase"
        style="height: 320px;"
      />
      <span slot="footer">
        <el-button v-show="isEdit" no="advanceTextDialogConfirm" type="primary" @click="finishAdvanceText">{{
          $t('common.btn.confirm')
        }}</el-button>
        <el-button no="advanceTextDialogClose" @click="advanceTextDialog.visible = false">{{
          $t('common.btn.close')
        }}</el-button>
      </span>
    </el-dialog>
    <!-- SOP接收人弹窗 -->
    <sop-dialog
      :visible.sync="sopDialog.visible"
      :cmp-idx="sopDialog.cmpIdx"
      :job="form"
      :agent="sopDialog.agent"
      lob="SE"
      :contact-list="sopDialog.contactList"
      @updateJob="$emit('updateJob')"
    />
    <!-- 抄录弹窗 -->
    <transcribe-dialog
      :visible.sync="transcribeDialog.visible"
      :job="form"
      @callback="transcribeCallback"
    />
    <!-- HS编号和中文品名检索弹窗 -->
    <hs-code-search-dialog
      :visible.sync="hsCodeSearchDialog.visible"
      :title="hsCodeSearchDialog.title"
      @callback="hsCodeSearchDialog.successCallback"
    />
    <!-- 操作要求弹窗 -->
    <select-operation-req-dialog
      :visible.sync="selectOperationReqDialog.visible"
      lob="SE"
      :value="selectOperationReqDialog.value"
      @callback="val => (form.operationContent = val)"
    />
    <!-- 附加费条款弹窗 -->
    <select-surcharge-terms-dialog
      :visible.sync="selectSurchargeTermsDialog.visible"
      :job-uuid="form.uuid"
      :row-data="selectSurchargeTermsDialog.rowData"
      :disabled="readonly"
      @callback="handleSurchargeTerms"
    />
    <!-- 收发通地址弹窗 -->
    <bill-address-dialog
      :visible.sync="billAddressDialog.visible"
      :job="form"
      @callback="codeSearchCallback"
    />
    <!-- 订舱章弹窗 -->
    <stamp-picture-view
      :visible.sync="stampPictureView.visible"
      :business-documents="stampPictureView.businessDocuments"
    />
    <!-- 加入拼箱工作单查询弹窗 -->
    <query-se-lcl-dialog
      :visible.sync="querySELclDialog.visible"
      :job="form"
      @callback="rows=>{pm.slavedAddedHandler(rows)}"
    />
    <!-- 票数填写弹框 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="ticketDialog.visible"
      :title="$t('SeaExport.FillInQuantityOfVotes')"
      width="270px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-form label-width="50px" label-position="right">
        <el-form-item :label="$t('SeaExport.Number')+'：'">
          <el-input-number v-model="ticketDialog.value" :precision="0" :min="1" :max="50" :controls="false" />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button type="primary" no="ticketDialogConfirm" @click="toAddTicket">{{ $t('common.btn.confirm') }}</el-button>
        <el-button type="primary" no="ticketDialogCancel" @click="ticketDialog.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { TabBuyerConsoleFclBookingMasterPM } from './tabBuyerConsoleFclBookingMasterPM'
import sopPic from '@/assets/sop.png'
import URL from '@/api/urlTranslator'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import cargoInput from '@/components/Cargo/Common/cargoInput'
import cargoButtonContainer from '@/components/Cargo/Common/cargoButtonContainer'
import sopDialog from '@/components/Cargo/Job/sopDialog'
import bookingSeaEqDataGrid from '@/components/Cargo/Job/bookingSeaEqDataGrid'
import transcribeDialog from '@/components/Cargo/Job/transcribeDialog'
import hsCodeSearchDialog from '@/components/Cargo/Job/hsCodeSearchDialog'
import cargoDepartmentNewSelect from '@/components/Cargo/Common/cargoDepartmentNewSelect'
import cargoDepartmentSelect from '@/components/Cargo/Common/cargoDepartmentSelect'
import cargoOfficeSelect from '@/components/Cargo/Common/cargoOfficeSelect'
import cargoUserSelect from '@/components/Cargo/Common/cargoUserSelect'
import cargoCompanySelect from '@/components/Cargo/Common/cargoCompanySelect'
import cargoProjectSelect from '@/components/Cargo/Common/cargoProjectSelect'
import cargoPackingSelect from '@/components/Cargo/Common/cargoPackingSelect'
import cargoRichTextarea from '@/components/Cargo/Common/cargoRichTextarea'
import specialRequestsGrid from '@/components/Cargo/Job/specialRequestsGrid'
import selectOperationReqDialog from '@/components/Cargo/Job/selectOperationReqDialog'
import selectSurchargeTermsDialog from '@/components/Cargo/Job/selectSurchargeTermsDialog'
import billAddressDialog from '@/components/Cargo/Job/billAddressDialog'
import selectData from '@/utils/selectData'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { TabError } from '@/utils/class/TabError'
import { CONTAINERLOAD_TYPES_LCL } from '@/class/cargo/model/parameters/ContainerLoadType'
import { BOOKING_TERMS } from '@/class/cargo/model/parameters/SeaExportConstants'
import { SPLIT_BILL_TYPE } from '@/class/cargo/model/parameters/BillType'
import {
  CARGO_SOURCES,
  EXPORT_CONTROLLED_PRODUCT,
  LOG_SE_SEA_BOOKING,
  RATE_TYPE,
  TAX_NATURES
} from '@/class/cargo/model/parameters/SystemConstants'
import * as CargoSource from '@/class/cargo/model/parameters/CargoSource'
import { SEUtils } from '@/class/cargo/model/utils/SEUtils'
import { SecurityUtil } from '@/class/cargo/model/utils/SecurityUtil'
import { User } from '@/class/model/sys/User'
import { Office } from '@/class/model/sys/Office'
import { Company } from '@/class/model/mdm/Company'
import { Customer } from '@/class/model/mdm/Customer'
import { Contract } from '@/class/model/mdm/Contract'
import { SeaExportJob } from '@/class/model/booking/SeaExportJob'
import { SeaCargoDoc } from '@/class/model/booking/SeaCargoDoc'
import { updateTrackingForDocumentType } from '@/api/fileHistory'
import { validateReleaseNumberCustomer } from '@/api/company'
import ChargeUtils from '@/class/cargo/model/utils/ChargeUtils'
import { ContainerUtil } from '@/class/cargo/model/utils/ContainerUtil'
import lang from '@/lang'
import { CargoDocUtil } from '@/class/cargo/model/utils/CargoDocUtil'
import stampIcon from '@/assets/stamp.jpg'
import StampPictureView from '@/components/Cargo/Job/stampPictureView'
import { ErrorTip } from '@/utils/class/ErrorTip'
import { validateDelJob } from '@/api/seaExport/seaExportJob'
import querySeLclDialog from '@/components/Cargo/Job/querySELclDialog'
import { getLoading } from '@/utils/utilBaseElement'
import AutoNumberInput from '@/components/Cargo/Common/AutoNumberInput'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import * as CargoDocConsts from '@/class/cargo/model/parameters/CargoDocConsts'
import { dateCompare } from '@/utils/commonUtil'
import CargoSalesCompanySelect from '@/components/Cargo/Common/cargoSalesCompanySelect'
import { SalesUtil } from '@/class/cargo/model/utils/SalesUtil'
import { DocumentManage } from '@/utils/commonUtil'
import CustomLableUtils from '@/utils/CustomLabelUtils'
import { checkPoNoIsExist } from '@/api/booking/job'
import { getObjectByCache } from '@/utils/basicDataCache'
import BasicTabMixin from '@/mixin/BasicTabMixin'
import { PrintTemplateUtil } from '@/class/cargo/model/utils/PrintTemplateUtil'
import { cache } from '@/utils/cacheManager'

export default {
  name: 'TabBuyerConsoleFclBookingMaster',
  filters: {
    filterWeek(val) {
      switch (val) {
        case 'TUE':
          return lang.t('SeaExport.TUE')
        case 'WED':
          return lang.t('SeaExport.WED')
        case 'THU':
          return lang.t('SeaExport.THU')
        case 'FRI':
          return lang.t('SeaExport.FRI')
        case 'SAT':
          return lang.t('SeaExport.SAT')
        case 'SUN':
          return lang.t('Pricing.Sun')
        case 'MON':
        default:
          return lang.t('SeaExport.MON')
      }
    }
  },
  components: {
    StampPictureView,
    cargoAdvanceSelect,
    cargoInput,
    cargoButtonContainer,
    sopDialog,
    bookingSeaEqDataGrid,
    transcribeDialog,
    hsCodeSearchDialog,
    cargoDepartmentNewSelect,
    cargoDepartmentSelect,
    cargoOfficeSelect,
    cargoUserSelect,
    cargoCompanySelect,
    cargoProjectSelect,
    cargoPackingSelect,
    specialRequestsGrid,
    selectOperationReqDialog,
    selectSurchargeTermsDialog,
    billAddressDialog,
    cargoRichTextarea,
    querySeLclDialog,
    AutoNumberInput,
    CargoSalesCompanySelect
  },
  mixins: [BasicTabMixin],
  props: {
    context: {
      type: Object,
      required: true
    },
    action: {
      type: String,
      required: true
    },
    viewSource: {
      // 页面请求发起方
      type: String,
      default: ''
    },
    cooperateEdit: { // 能否修改
      type: Boolean,
      default: true
    },
    processingPromiseList: { // 正在处理中的异步操作对象列表
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      visible: false, // 先隐藏，避免组件在初始化完成前，做一些无效的处理（频繁刷新组件、调用接口等）
      pm: new TabBuyerConsoleFclBookingMasterPM(this),
      sopPic,
      SEUtils,
      URL,
      selectTypeNames: TYPE_NAMES,
      contractStatuses: selectData.contractStatuses,
      containerLoadTypes: CONTAINERLOAD_TYPES_LCL,
      CARGO_SOURCES,
      TAX_NATURES,
      EXPORT_CONTROLLED_PRODUCT,
      rateType: RATE_TYPE,
      bookingTerms: BOOKING_TERMS,
      partnerManagementMode: 0,
      lclslaveEnabled: false, // 拼箱小票
      salesOfficeCheck: false, // 是否按照分公司控制 (1:开启分公司过滤 0:关闭分公司过滤)
      branchOfficeCheck: false,
      creditOpen: false,
      isShowContactPersonDetail: false, // 海创显示详细信息
      isHC: false,
      notUppercaseShipperConsigneNotify: true, // CARGO-47047 收发通大小写控制
      isUppercaseByConfig: true, // CARGO-49117 是否大写
      openProjectConfig: false,
      salesCanSeeBookingAgent: false,
      sopConfigOpen: false,
      sopImageA: false,
      sopImageB: false,
      sopImageC: false,
      form: new SeaExportJob().fillDefaultValue().getData(),
      mblDoc: new SeaCargoDoc().fillDefaultValue().getData(),
      hdoc: new SeaCargoDoc().fillDefaultValue().getData(),
      seaEqList: [],
      cargoBulkDetailList: [],
      customJobTypeList: [],
      showWarningImageA: false,
      warningImageATip: '',
      showWarningImageB: false,
      warningImageBTip: '',
      showWarningImageC: false,
      warningImageCTip: '',
      customerLevel: {
        level: '',
        customerName: ''
      },
      advancePaymentLabel: '', // 预付款(中邮)
      contractStatus: 0,
      contractStatusLabel: '',
      customerTip: '',
      contactList: [],
      etdEnabled: false,
      cargoSourceEnabled: false,
      salesList: null,
      salesPrompt: '',
      txtWhs: '', // 入库信息
      txtSalesOffice: '', // 销售所在分公司
      overseaAgentUsersList: [], // 海外客服用户列表
      txtSurchargeTerms: '', // 附加费条款
      contactDialog: {
        visible: false,
        data: {}
      },
      advanceTextDialog: {
        visible: false,
        title: '',
        value: '',
        successCallback: null,
        isUppercase: false,
        formatObj: {
          warningCount: -1,
          maxChar: 0,
          autoUppercase: true
        }
      },
      sopDialog: {
        visible: false,
        cmpIdx: 0,
        agent: '',
        contactList: []
      },
      transcribeDialog: {
        visible: false
      },
      hsCodeSearchDialog: {
        visible: false,
        title: '',
        successCallback: () => {}
      },
      selectOperationReqDialog: {
        visible: false,
        value: ''
      },
      selectSurchargeTermsDialog: {
        visible: false,
        rowData: []
      },
      billAddressDialog: {
        visible: false
      },
      stampIcon, // 订舱章
      stampPictureView: {
        businessDocuments: [], // 不为空则显示订舱章
        visible: false
      },
      isTabContainerInfo: true, // // CARGO-7908 当基本页签切换非装箱信息页签不去覆盖基本页签实际件毛体(cargo 中在bookingworkspace 中设置的是true)
      btnSave: true,
      overseaAgentDataProviderChange: false, // 目的港代理数据源是否发生变更
      bookingAgentDataProviderChange: false, // 订舱代理数据源是否发生变更
      customerRefNoTip: '', // 业务参考号鼠标悬浮提示
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        onRowDataChanged: event => {
          this.onRowDataChanged(event)
        },
        onCellFocused: event => {
          this.selectedRowIndex = event.rowIndex
        },
        onSelectionChanged: event => {
          // 触发多选
          this.onMultipleSelected(event)
        },
        onCellDoubleClicked: event => {
          this.btnLcLEditClickHandler(event)
        },
        context: {
          componentParent: this
        }
      },
      columnDefs: [
        {
          headerName: '',
          colId: 'uuid',
          field: '',
          width: 40,
          headerCheckboxSelection: true,
          checkboxSelection: true,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false
        },
        {
          headerName: this.$t('SeaExport.BusinessNo'),
          colId: 'jobNo',
          field: 'jobNo',
          width: 150
        }, {
          headerName: this.$t('SeaExport.SoNo'),
          colId: 'soNo',
          field: 'soNo',
          hide: true,
          width: 120
        }, {
          headerName: this.$t('SeaExport.WarehouseNo'),
          colId: 'warehouseNo',
          field: 'warehouseNo',
          width: 120
        }, {
          headerName: this.$t('SeaExport.Mbl'),
          colId: 'mbl',
          field: 'mbl',
          width: 100
        }, {
          headerName: this.$t('SeaExport.ConsignationCompany'),
          colId: 'customerId',
          field: 'customerId',
          width: 120,
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          }
        }, {
          headerName: this.$t('SeaExport.PortOfDischarge'),
          colId: 'dischargingPortCode',
          field: 'dischargingPortCode',
          width: 140,
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
          }
        }, {
          headerName: this.$t('SeaExport.PlaceOfDelivery'),
          colId: 'destinationPortCode',
          field: 'destinationPortCode',
          width: 100,
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
          }
        }, {
          headerName: this.$t('SeaExport.Etd'),
          colId: 'etd',
          field: 'etd',
          width: 100,
          cellRenderer: params => {
            return ColumnUtils.formateDateToString(params.value, 'yyyy-MM-dd')
          }
        }, {
          headerName: this.$t('SeaExport.ChineseDescriptionOfGoods'),
          colId: 'cargoChineseName',
          field: 'cargoChineseName',
          width: 120
        }, {
          headerName: this.$t('SeaExport.EnglishDescriptionOfGoods'),
          colId: 'cargoEnglishName',
          field: 'cargoEnglishName',
          width: 120
        }, {
          headerName: this.$t('SeaExport.ActualQuantity'),
          colId: 'quantityActual',
          field: 'quantityActual',
          width: 120,
          cellRenderer: params => {
            return ColumnUtils.numberColumnLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('SeaExport.ActualWeight'),
          colId: 'weightActual',
          field: 'weightActual',
          width: 120,
          cellRenderer: params => {
            return ColumnUtils.numberColumnLabelFunc(params.value, 3)
          }
        }, {
          headerName: this.$t('SeaExport.ActualVolume'),
          colId: 'cubageActual',
          field: 'cubageActual',
          width: 120,
          cellRenderer: params => {
            return ColumnUtils.number3ColumnLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('SeaExport.ChargedWeight'),
          colId: 'chargeWeight',
          field: 'chargeWeight',
          width: 120,
          cellRenderer: params => {
            return ColumnUtils.numberColumnLabelFunc(params.value, 3)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_AuthorizedQuantity'),
          colId: 'quantityContract',
          field: 'quantityContract',
          width: 120,
          hide: true,
          cellRenderer: params => {
            return ColumnUtils.numberColumnLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_CommissionedGrossWeight'),
          colId: 'weightContract',
          field: 'weightContract',
          width: 120,
          hide: true,
          cellRenderer: params => {
            return ColumnUtils.numberColumnLabelFunc(params.value, 3)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_AuthorizedCubage'),
          colId: 'cubageContract',
          field: 'cubageContract',
          width: 120,
          hide: true,
          cellRenderer: params => {
            return ColumnUtils.number3ColumnLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('queryJob.destinationAgent'),
          field: 'destinationAgent',
          colId: 'destinationAgent',
          cellRenderer: (params) => {
            return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'auto_2') : ''
          },
          hide: true,
          width: 120
        }, {
          headerName: this.$t('SeaExport.NominatedAgent'),
          field: 'designationAgent',
          colId: 'designationAgent',
          cellRenderer: (params) => {
            return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'auto_3') : ''
          },
          hide: true,
          width: 120
        }
      ],
      gridApi: null,
      selectedRowIndex: -1,
      selectedRows: [],
      querySELclDialog: {
        visible: false
      },
      ticketDialog: {
        visible: false,
        value: 0
      },
      opEabled: false,
      JobUtils,
      divisionEnabled: false,
      divisionHeight: 10,
      doc: new DocumentManage(),
      poNoRed: false,
      needConfirmProjectNo: false,
      location: LOG_SE_SEA_BOOKING.code,
      userPortRoleData: {
        userDefinedRole1: null,
        userDefinedRole2: null,
        overseaOp: null,
        siteOp: null,
        doc: null,
        csr: null,
        op: null,
        seaLine: null,
        airline: null,
        railwayLine: null
      },
      cargoSalesList: null
    }
  },
  computed: {
    isZh() {
      return this.$store.getters.language === 'zh'
    },
    readonly() {
      if (!this.cooperateEdit) return true
      return !this.isEdit
    },
    isEdit() {
      if (!this.cooperateEdit) return false
      return this.action !== 'look' && !this.form.printHblZbLock
    },
    // 通过正本打印锁定业务
    lockJobByPrintHblZb() {
      if (!this.cooperateEdit) return false
      if (this.action !== 'look') {
        return this.form.printHblZbLock
      }
      return false
    },
    mblOnly() {
      return this.form.mblOnly
    },
    isHbl() {
      return this.form.typeHBL === SPLIT_BILL_TYPE.code
    },
    bookingAgentEnabled() {
      return (
        this.lclslaveEnabled &&
        SecurityUtil.checkOffsetAutoCompleteEnabled(
          this.form,
          'bookingAgent'
        ) &&
        (this.pm.isJoinCarrierBookingAgent &&
        this.form.containerLoadType !== 'BB'
          ? this.form.carrierId > 0
          : true)
      )
    },
    carrierIdEnabled() {
      return (
        this.lclslaveEnabled &&
        SecurityUtil.checkOffsetAutoCompleteEnabled(this.form, 'carrierId')
      )
    },
    designationAgentEnabled() {
      return (
        this.isEdit &&
        SecurityUtil.checkOffsetAutoCompleteEnabled(
          this.form,
          'designationAgent'
        )
      )
    },
    customsBrokerEnabled() {
      if (!this.form.customs) {
        return false
      }
      if (
        !SecurityUtil.checkOffsetAutoCompleteEnabled(this.form, 'customsBroker')
      ) {
        return false
      }
      return true
    },
    warehouseEabled() {
      if (!this.form.warehousing) {
        return false
      }
      if (
        !SecurityUtil.checkOffsetAutoCompleteEnabled(this.form, 'warehouseCmp')
      ) {
        return false
      }
      return true
    },
    cubageActualEnabled() {
      return (
        this.isEdit &&
        !this.pm.billChargeFlag &&
        SecurityUtil.checkOffsetChargeMeasure(this.form, 'WCB')
      )
    },
    saleEnabled() {
      return (
        ((this.pm.trustFromEditSales ? true : !this.form.trustFromJob) ||
          this.pm.isCrossTenant) &&
        this.pm.canChangeSalesOfJob &&
        !this.pm.isWithinCloseAccountDate
      )
    },
    config() {
      return this.context.config
    },
    customerEnabled() {
      return (
        this.isEdit &&
        SecurityUtil.checkOffsetAutoCompleteEnabled(this.job, 'customerId')
      )
    },
    chargeWeightEnabled() {
      return (
        this.isEdit && SecurityUtil.checkOffsetChargeMeasure(this.job, 'WGTX')
      )
    },
    rowData() {
      return this.form.lclSlaves || []
    },
    selectedRow() {
      return this.rowData[this.selectedRowIndex]
    },
    containerLoadTypeEnabled() {
      return this.isEdit && (!this.form.uuid || (this.form.uuid && !this.form.masterFlag))
    },
    showChannelNo() {
      return ['B2B', this.$t('Menu.WallTechFamily')].includes(this.form.salesChannel)
    },
    bookingAgentVisible() {
      return SalesUtil.salesCanBookingAgent(this.salesCanSeeBookingAgent)
    },
    divisionHalfHeight() {
      return this.divisionHeight / 2
    },
    // 销售分公司
    salesOffice() {
      return this.form.salesOffice
    },
    isJyd() { // 是否集翊达
      return this.config && String(this.config.get('ToExoSystem')) === 'JYD'
    },
    isJydEditJobFields() { // 有客服权限，没有操作权限，则不能编辑业务的某些字段【新增业务除外】
      return JobUtils.editJobFields(this.isJyd && this.form.uuid)
    },
    isJydUpdateCustomsDate() { // 集翊达判断有编辑操作日期权限，不是则默认可以编辑
      return this.isJyd ? this.$checkPermission(['role_SEBooking_UpdateCustomsDate']) : true
    }
  },
  watch: {
    mblOnly(newVal) {
      if (newVal) {
        this.form.signHBL = false
      }
    },
    'form.surchargeTerms': {
      handler(newValue) {
        if (!newValue) {
          this.txtSurchargeTerms = ''
          return
        }
        let text = ''
        console.log('surchargeTerms', newValue)
        for (const item of newValue) {
          if (item.deleted) {
            continue
          }
          const chargeItemCode = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeItem, 'itemId', item.chargeItemId, 'chargecode')
          console.log('chargeItemCode', chargeItemCode)
          if (chargeItemCode === 'HYF') {
            if (this.form.signMBL || (!this.form.signMBL && !this.form.signHBL)) {
              this.form.paymentTermMBL = item.terms
            } else {
              this.form.paymentTermHBL = item.terms
            }
            item.deleted = true
            continue
          }
          if (text) {
            text += '\n'
          }

          const chargeItemName = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeItem, 'itemId', item.chargeItemId, 'zhName')
          if (typeof chargeItemName === 'string' && chargeItemName.startsWith('HDS')) {
            this.form.hds = true
          }
          text += `${chargeItemName}：${item.terms}`
        }
        this.txtSurchargeTerms = text
      }
    }
  },
  created() {
    this.partnerManagementMode = Number(
      this.config.get('PartnerManagementMode')
    ) // 是否启用合作伙伴管理模式
    this.salesOfficeCheck = Number(this.config.get('SalesOfficeCheck')) === 1
    this.branchOfficeCheck =
      Number(this.config.get('departmentSalesOfficeCheck')) === 1
    this.creditOpen = Number(this.config.get('creditOpen')) === 1
    // const sop = await SopPushConfig.findByOfficeId(this.$store.getters.currentOfficeId)
    // if (sop) {
    //   this.sopConfigOpen = sop.ifAuto
    // }
    this.isHC = String(cache.config.get('ToExoSystem')) === 'HC'
    this.isShowContactPersonDetail = String(this.config.get('ToExoSystem')) === 'HC'
    this.notUppercaseShipperConsigneNotify = Number(this.config.get('NotUppercaseShipperConsigneNotify')) !== 1
    this.isUppercaseByConfig = Number(this.config.get('autoUppercaseEnabled')) === 0 // CARGO-49117 英文品名、唛头可以支持小写字 为0就大写 1可以大写可以小写
    this.pm.init()
  },
  mounted() {
    this.doc.set('dragging', e => {
      if (!this.divisionEnabled) {
        return
      }
      this.dragging(e)
    })
    this.doc.set('endDrag', () => {
      document.getElementById('app').classList.remove('disabled-select')
      this.divisionEnabled = false
    })
    document.addEventListener('mousemove', this.doc.get('dragging'), false)
    document.addEventListener('mouseup', this.doc.get('endDrag'), false)
    document.addEventListener('mouseleave', this.doc.get('endDrag'), false)
  },
  beforeDestroy() {
    document.removeEventListener('mousemove', this.doc.get('dragging'), false)
    document.removeEventListener('mouseup', this.doc.get('endDrag'), false)
    document.removeEventListener('mouseleave', this.doc.get('endDrag'), false)
    this.doc.destory()
  },
  methods: {
    async onShow(row, isRefresh) {
      if (!row.uuid) {
        row.booking = true
      }
      if (this.isEdit) {
        if (this.form.uuid) {
          this.opEabled = await SecurityUtil.canEdit(this.form, false)
        } else {
          this.opEabled = true
        }
      }
      if (!isRefresh) {
        this.pm.formInitialValue = { ...this.form }
        return
      }
      // 刷新 客户需求表格【控件里有监听委托单位的事件，这里不需要调用查询方法】
      // if (this.$refs['selectedSpecialRequest']) {
      //   this.$refs['selectedSpecialRequest'].toQuery()
      // }
      this.openProjectConfig =
        Number(this.config.get('openProjectConfig')) === 1
      this.salesCanSeeBookingAgent = Number(this.config.get('SalesCanSeeBookingAgent')) === 1
      this.needConfirmProjectNo = Number(this.config.get('needConfirmProjectNo')) === 1
      for (const key in this.userPortRoleData) {
        this.userPortRoleData[key] = null
      }
      const job = new SeaExportJob(row)
      console.log(job)
      if (!row.uuid) {
        job.seaCargoDoc = job.seaCargoDoc || []
        this.mblDoc = await job.getMainMbl()
        if (!this.mblDoc) {
          this.mblDoc = new SeaCargoDoc().fillDefaultValue().getData()
          this.initCargoDoc(this.mblDoc, row, 'MBL')
        }
        if (!this.mblDoc.cargoManifestName) {
          this.mblDoc.cargoManifestName = job.cargoEnglishName
        }
        this.hdoc = await job.getMainHbl()
        if (!this.hdoc) {
          this.hdoc = new SeaCargoDoc().fillDefaultValue().getData()
          this.initCargoDoc(this.hdoc, row, 'HBL')
        }
        if (!this.hdoc.cargoManifestName) {
          this.hdoc.cargoManifestName = job.cargoEnglishName
        }
        this.seaEqList = job.seaEQ = job.seaEQ || []
        this.cargoBulkDetailList = job.cargoBulkDetail =
          job.cargoBulkDetail || []
        this.customerLevel.level = ''
        this.customerLevel.customerName = ''
        this.advancePaymentLabel = ''
        this.contractStatus = 0
        this.contractStatusLabel = ''
        this.customerTip = ''
        if (row.paymentTermHBL === 'PP') {
          const ports = this.context.seaPortList.filter(
            p => p.code === row.loadingPortCode
          )
          if (ports && ports.length > 0) {
            row.paymentPlaceHBL = ports[0].englishName
          }
        } else if (row.paymentTermHBL === 'CC' || row.paymentTermHBL === '3P') {
          const ports = this.context.seaPortList.filter(
            p => p.code === row.destinationPortCode
          )
          if (ports && ports.length > 0) {
            row.paymentPlaceHBL = ports[0].englishName
          }
        }
      } else {
        this.mblDoc = await job.getMainMbl()
        if (!this.mblDoc) {
          this.mblDoc = new SeaCargoDoc().fillDefaultValue().getData()
          this.initCargoDoc(this.mblDoc, row, 'MBL')
        }
        this.hdoc = await job.getMainHbl()
        if (!this.hdoc) {
          this.hdoc = new SeaCargoDoc().fillDefaultValue().getData()
          this.initCargoDoc(this.hdoc, row, 'HBL')
        }
        this.seaEqList = job.seaEQ || []
        this.cargoBulkDetailList = job.cargoBulkDetail
      }
      this.form = row
      this.pm.changeJob()
      this.pm.fillView()
      this.loadCustomerIdContractInfo()
      this.cargoSourceEnabled = this.isEdit
      this.salesList = null
      this.salesPrompt = ''
      this.overseaAgentUsersList = []
      this.mergeSurchargeTerms()
      row.printHblZbLock = false
      this.overseaAgentDataProviderChange = false
      this.bookingAgentDataProviderChange = false
      if (!this.isEdit && this.form.poNo && this.needConfirmProjectNo && !this.openProjectConfig) {
        this.poNoRed = await checkPoNoIsExist(this.form.poNo, this.form.uuid).then(res => res.data) > 0
      }
      JobUtils.loadCompanyCargoSales(this, this.form, this.pm.isSpecifiedSalesBusiness)
      if (this.isEdit) {
        this.setCustomJobTypeFunc()
      }
    },
    setCustomJobTypeFunc() {
      this.customJobTypeList = JobUtils.setCustomJobTypeList(this.form.lob, this.form.containerLoadType, this.form.fba)
    },
    initCargoDoc(doc, row, docType) {
      new SeaCargoDoc(doc).reset()
      doc.docType = docType
      doc.mark = row.mark
      doc.cargoEnglishName = row.cargoEnglishName
      // if (docType === 'MBL') {
      doc.notifyLine1 = 'SAME AS CONSIGNEE'
      // }
      // 提单发货地，应该是seaopinput.placeOfReceipt
      doc.dispatchingPlace = row.dispatchingPlace
      // 提单起运港
      if (row.loadingPortCode) {
        console.log('posr', this)
        const ports = this.context.seaPortList.filter(
          p => p.code === row.loadingPortCode
        )
        if (ports && ports.length > 0) {
          doc.loadingPort = ports[0].englishName
          doc.loadingPortCode = row.loadingPortCode
        }
      }
      // 提单卸货港
      if (row.dischargingPortCode) {
        const ports = this.context.seaPortList.filter(
          p => p.code === row.dischargingPortCode
        )
        if (ports && ports.length > 0) {
          doc.dischargingPort = ports[0].englishName
          doc.dischargingPortCode = row.dischargingPortCode
        }
      }
      // 提单目的港
      if (row.destinationPortCode) {
        const ports = this.context.seaPortList.filter(
          p => p.code === row.destinationPortCode
        )
        if (ports && ports.length > 0) {
          doc.destinationPort = ports[0].englishName
          doc.destinationPortCode = row.destinationPortCode
        }
      }
      if (doc.docType !== 'MBL' && doc.docType !== 'MBL2') {
        // 提单收货地
        doc.destinationPlace = row.destinationPlace
      }
      if (doc.docType === 'MBL' && row.masterFlag) {
        doc.shipperLine1 = this.context.office.seaAddressLine1
        doc.shipperLine2 = this.context.office.seaAddressLine2
        doc.shipperLine3 = this.context.office.seaAddressLine3
        doc.shipperLine4 = this.context.office.seaAddressLine4
        doc.shipperLine5 = this.context.office.seaAddressLine5
        doc.shipperLine6 = this.context.office.seaAddressLine6
      }
      // 通过参数BillOfLadingSynMode同步件毛体和包装
      CargoDocUtil.changeJobSynToBillOfLading(row, doc)
      // 根据参数判断是否同步小件数包装
      const isInsidePacking = Number(this.config.get('seaInsidePacking'))
      if (isInsidePacking === 1) {
        doc.insidePacking = row.insidePacking
      }
      // doc.issuerBL = 'UBI'
      ColumnUtils.customOrderFormTypeFunc(doc)
      // 新增时，如果已经选择提单方式，会重置为默认值
      if (!doc.releaseType) {
        const releaseType = Number(this.config.get('ReleaseTypeDefaultValue'))
        if (releaseType === 1) {
          doc.releaseType = 1
          doc.blNumber = 'THREE'
        } else if (releaseType === 2) {
          doc.releaseType = 3
          doc.blNumber = 'ONE'
        }
      } else {
        // 重置提单份数
        if (doc.releaseType === 1) {
          doc.BLNumber = 'THREE'
        } else {
          doc.BLNumber = 'ONE'
        }
      }
      doc.state = 1
      row.seaCargoDoc.push(doc)
    },
    showContactDialog() {
      if (!this.form.customerContact) {
        return
      }
      for (const item of this.contactList) {
        if (item.contactPerson === this.form.customerContact) {
          this.contactDialog.data = item
          this.contactDialog.visible = true
          return
        }
      }
      this.contactDialog.data = {}
      this.contactDialog.visible = true
    },
    showAdvanceTextDialog(
      title,
      value,
      successCallback,
      isUppercase = false,
      formatObject = null
    ) {
      this.advanceTextDialog.title = title
      this.advanceTextDialog.value = value
      this.advanceTextDialog.successCallback = successCallback
      this.advanceTextDialog.isUppercase = isUppercase
      const defaultFormatObj = {
        warningCount: -1,
        maxChar: 0
      }
      this.advanceTextDialog.formatObj = formatObject
        ? { ...defaultFormatObj, ...formatObject }
        : defaultFormatObj
      this.advanceTextDialog.visible = true
      this.$nextTick(() => {
        this.$refs.advanceTextDialogTextarea.editor.focus()
      })
    },
    finishAdvanceText() {
      const successCallback = this.advanceTextDialog.successCallback
      if (successCallback && typeof successCallback === 'function') {
        successCallback(this.advanceTextDialog.value)
      }
      this.advanceTextDialog.visible = false
    },
    // 加载委托单位签约信息
    async loadCustomerIdContractInfo() {
      let company = this.context.companyList.find(
        p => p.cmpIdx === this.form.customerId
      )
      this.showWarningImageB = false
      this.sopImageB = false
      this.customerLevel.level = ''
      this.customerLevel.customerName = ''
      this.advancePaymentLabel = ''
      this.contractStatus = 0
      this.contractStatusLabel = ''
      this.customerTip = ''
      this.contactList = []
      this.stampPictureView.businessDocuments = []
      if (!company || !company.cmpIdx) {
        return
      }
      company = new Company(company)
      if (this.creditOpen) {
        this.pm.checkCreditByCompany(company.cmpIdx, 1)
      }
      await this.loadCustomerDetial(company)
      this.pm.getContractStatus(company) // 获取合约状态
      this.contactList = await company.getContacts()
    },
    // 判断选中的委托单位，是否禁止到期合同创建业务，CARGO-7885
    async customerIdChange2ContractHandler(company) {
      this.showWarningImageB = false
      this.sopImageB = false
      this.customerLevel.level = ''
      this.customerLevel.customerName = ''
      this.advancePaymentLabel = ''
      this.contractStatus = 0
      this.contractStatusLabel = ''
      this.customerTip = ''
      this.contactList = []
      this.cargoSalesList = null
      this.form.customerContact = ''
      this.form.editCftMode = false
      this.stampPictureView.businessDocuments = []
      if (this.form.customerId && parseInt(this.form.customerId) > 0) {
        this.form.preCustomerId = this.form.customerId
      }
      if (!company.cmpIdx) {
        this.form.customerId = 0
        return
      }
      const validateRes = await validateReleaseNumberCustomer({
        companyId: company.cmpIdx,
        officeId: this.$store.getters.currentOfficeId
      })
      if (validateRes && validateRes.data && validateRes.data.allowed === false) {
        if (validateRes.data.message) {
          this.$message.warning(validateRes.data.message)
        }
        this.form.customerId = 0
        console.log('[ReleaseNumber] SE BuyerConsole clear', !!this.$refs.customerSelect)
        if (this.$refs.customerSelect && this.$refs.customerSelect.clear) {
          this.$refs.customerSelect.clear()
        }
        return
      }
      // 中邮委托单位是否黑名单
      const blacklist = await JobUtils.checkBlacklistByCustomerId(company.cmpIdx)
      if (blacklist) {
        // return
      }
      // 这个验证必须在 this.form.customerId = company.cmpIdx 赋值之前，否则此验证无意义
      SEUtils.refreshChargeAccountId(
        this.form,
        'customerId',
        this.$t('SeaExport.ConsignationCompany'),
        this.context.modifiedData
      ) // 这里返回true 说明修改了费用结算对象以及开票抬头，需要将费用参与保存
      this.form.customerId = company.cmpIdx

      company = new Company(company)
      if (this.creditOpen) {
        this.pm.checkCreditByCompany(company.cmpIdx, 1)
        this.pm.checkNewJobCreditInfo()
      }
      const isForbid = await Contract.isContractExpiredForbidCreateJob(
        company.cmpIdx
      )
      if (isForbid) {
        this.form.customerId = 0
        this.$message.info(this.$t('Message.ContractExpireCannotCreated'))
        return
      }

      await this.loadCustomerDetial(company)
      this.pm.getContractStatus(company) // 获取合约状态
      this.contactList = await company.getContacts()
      const contact = this.getDefaultContact(this.contactList)
      this.form.customerContact = contact ? contact.contactPerson : ''
      this.pm.onCustomerContactLoad()
      this.pm.onCustomerDetailLoad()
      this.pm.loadCustomerPortDestinationAgents()
      this.pm.loadCompanyUser() // 销售
      if (company.mustInputScn) {
        this.form.editCftMode = true
      }
      JobUtils.loadCompanyCargoSales(this, this.form, this.pm.isSpecifiedSalesBusiness, true)
    },
    getDefaultContact(contactList) {
      if (!contactList || contactList.length <= 0) return ''
      const c = contactList.find(item => item.defaultContact)
      return c || contactList[0]
    },
    async loadCustomerDetial(company) {
      let customer = await company.getCustomerDetail()
      this.advancePaymentLabel = company && company.ifAdvancePayment ? this.$t('Partners.IfAdvancePayment') : ''
      this.customerLevel.level = ''
      this.customerLevel.customerName = ''
      if (customer) {
        customer = new Customer(customer)
        const customerType = await customer.getCustomerType()
        // console.log('customerType', customerType)
        if (customerType) {
          this.customerLevel.level = customerType.typeId
          this.customerLevel.customerName = this.isZh ? customerType.chineseName : customerType.englishName
        }
      }
    },
    async etdChange(value) {
      await JobUtils.etdChange(value, this.form, this.context, this.isJyd)
    },
    async atdChange(value) {
      const oldValue = this.form.atd
      this.form.atd = value
      this.form.atdSailingDay = JobUtils.dateChange(this.form.atd)
      if (parseInt(this.config.get('syncSignDateBl')) === 1) {
        const cargoDocList = await new SeaExportJob(this.form).getSeaCargoDoc()
        for (const cargoDoc of cargoDocList) {
          const allow = (cargoDoc.docType === CargoDocConsts.MBL || cargoDoc.docType === CargoDocConsts.MBL2 ||
            cargoDoc.docType === CargoDocConsts.HBL || cargoDoc.docType === CargoDocConsts.HBL2 ||
            cargoDoc.docType === CargoDocConsts.HAWB2) && cargoDoc.state < 2 && (!cargoDoc.signDateBL ||
            (oldValue && dateCompare(cargoDoc.signDateBL, oldValue) === 0))
          if (allow) {
            cargoDoc.signDateBL = this.form.atd
          }
        }
      }
    },
    ataChange(value) {
      this.form.ata = value
      this.form.ataSailingDay = JobUtils.dateChange(this.form.ata)
    },
    transcribeCallback(data) {
      for (const key in data) {
        this.form[key] = data[key]
      }
    },
    showHsCodeSearchDialog(title, successCallback) {
      this.hsCodeSearchDialog.title = title
      this.hsCodeSearchDialog.successCallback = successCallback
      this.hsCodeSearchDialog.visible = true
    },
    async salesChange(data) {
      const form = this.form
      form.sales = data.value
      if (data.defaultOfficeId) {
        // 用户设置了默认公司和部门就用默认的
        form.salesOffice = data.defaultOfficeId
        form.salesDepartment = data.defaultDepId
        const office = await Office.getOfficeById(this.form.salesOffice)
        this.salesOfficeText = office.chineseName
      } else {
        const user = new User(data)
        const department = user.getDefaultDepartment('role', 'sales')
        const office = Office.getOfficeByUuid(department.officeUuid)
        form.salesOffice = office.officeId
        form.salesDepartment = department.departmentId
        this.salesOfficeText = office.chineseName
      }
    },
    handleSurchargeTerms(data) {
      const surchargeTerms = this.form.surchargeTerms
      surchargeTerms.splice(0, surchargeTerms.length)
      surchargeTerms.push(...data)
      this.mergeSurchargeTerms()
    },
    mergeSurchargeTerms() {
      console.log(this.form.surchargeTerms)
      let text = ''
      for (const item of this.form.surchargeTerms) {
        if (item.deleted) {
          continue
        }
        if (text) {
          text += '\n'
        }
        const chargeItemName = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeItem, 'itemId', item.chargeItemId, 'zhName')
        if (typeof chargeItemName === 'string' && chargeItemName.startsWith('HDS')) {
          this.form.hds = true
        }
        text += `${chargeItemName}：${item.terms}`
      }
      this.txtSurchargeTerms = text
    },
    codeSearchCallback(data) {
      if (data.shipperInfo) {
        this.splitShipperLine(data.shipperInfo)
      }
      if (data.consigneeInfo) {
        this.splitConsigneeLine(data.consigneeInfo)
      }
      if (data.notifyInfo) {
        this.splitNotifyLine(data.notifyInfo)
      }
      if (data.hasOwnProperty('shipperCode')) {
        this.form['shipperCode'] = data.shipperCode || ''
      }
      if (data.hasOwnProperty('consigneeCode')) {
        this.form['consigneeCode'] = data.consigneeCode || ''
      }
      if (data.hasOwnProperty('notifyCode')) {
        this.form['notifyCode'] = data.notifyCode || ''
      }
    },
    mergeShipperLine() {
      let result = ''
      for (let i = 1; i < 7; ++i) {
        result += this.form['shipperLine' + i] || ''
        result += '\n'
      }
      result += this.form['shipperLine7'] || ''
      return result.trimEnd()
    },
    splitShipperLine(val) {
      let fromIndex = 0
      let i = 1
      for (; i < 7; ++i) {
        const index = val.indexOf('\n', fromIndex)
        if (index === -1) {
          break
        }
        this.form['shipperLine' + i] = val.substring(fromIndex, index)
        fromIndex = index + 1
      }
      this.form['shipperLine' + i] = val.substring(fromIndex)
      for (++i; i < 8; ++i) {
        this.form['shipperLine' + i] = ''
      }
    },
    mergeConsigneeLine() {
      let result = ''
      for (let i = 1; i < 7; ++i) {
        result += this.form['consigneeLine' + i] || ''
        result += '\n'
      }
      result += this.form['consigneeLine7'] || ''
      return result.trimEnd()
    },
    splitConsigneeLine(val) {
      let fromIndex = 0
      let i = 1
      for (; i < 7; ++i) {
        const index = val.indexOf('\n', fromIndex)
        if (index === -1) {
          break
        }
        this.form['consigneeLine' + i] = val.substring(fromIndex, index)
        fromIndex = index + 1
      }
      this.form['consigneeLine' + i] = val.substring(fromIndex)
      for (++i; i < 8; ++i) {
        this.form['consigneeLine' + i] = ''
      }
    },
    mergeNotifyLine() {
      let result = ''
      for (let i = 1; i < 7; ++i) {
        result += this.form['notifyLine' + i] || ''
        result += '\n'
      }
      result += this.form['notifyLine7'] || ''
      return result.trimEnd()
    },
    splitNotifyLine(val) {
      let fromIndex = 0
      let i = 1
      for (; i < 7; ++i) {
        const index = val.indexOf('\n', fromIndex)
        if (index === -1) {
          break
        }
        this.form['notifyLine' + i] = val.substring(fromIndex, index)
        fromIndex = index + 1
      }
      this.form['notifyLine' + i] = val.substring(fromIndex)
      for (++i; i < 8; ++i) {
        this.form['notifyLine' + i] = ''
      }
    },
    async getSubmitData() {
      // CARGO-20365先触发富文本组件失焦事件去除尾部换行符
      if (this.$refs.cargoTextarea1) this.$refs.cargoTextarea1.hanldeFormat()
      if (this.$refs.cargoTextarea2) this.$refs.cargoTextarea2.hanldeFormat()
      await this.validateForm()

      // 校验 装箱和基本页签的件毛体是否一致
      const msg = ContainerUtil.validateContainerUsage(this.form)
      if (msg) {
        throw new TabError(msg, 'tabBuyerConsoleFclBookingMaster')
      }

      if (this.form.customerContact) {
        for (const item of this.contactList) {
          if (item.contactPerson === this.form.customerContact) {
            this.form.contactEmail = item.email
          }
        }
      }
      const job = { ...this.form }
      // 清空子表数据
      // for (const key in job) {
      //   if (typeof job[key] === 'object') {
      //     job[key] = undefined
      //   }
      // }
      const seaCargoDoc = []
      // 不管是否勾选MBL 保存的时候都要生成MBL记录
      // if (job.signMBL) {
      seaCargoDoc.push(this.mblDoc)
      if (job.mblOnly) {
        new SeaCargoDoc(this.mblDoc).copyBasicShipper(job)
        new SeaCargoDoc(this.mblDoc).copyBasicConsignee(job)
        new SeaCargoDoc(this.mblDoc).copyBasicNotify(job)
      }
      // }
      // 不管是否勾选MBL 保存的时候都要生成HBL记录
      // if (job.signHBL) {
      seaCargoDoc.push(this.hdoc)
      // }
      if (job.ams) {
        let amsDoc = await new SeaExportJob(this.form).getCargoDocByType('AMS', false)
        if (!amsDoc) {
          amsDoc = await CargoDocUtil.addAMS(this.form, true)
          amsDoc.dispatchingPlace = this.hdoc.dispatchingPlace // 提单发货地
          amsDoc.loadingPort = this.hdoc.loadingPort // 提单起运港
          amsDoc.dischargingPort = this.hdoc.dischargingPort // 提单卸货港
          amsDoc.destinationPort = this.hdoc.destinationPort // 提单目的港
          amsDoc.destinationPlace = this.hdoc.destinationPlace // 提单目的地
          amsDoc.quantity = 0 // 提单件数
          amsDoc.weight = 0 // 重量
          amsDoc.cubage = 0 // 体积
          amsDoc.jobUuid = this.form.uuid
          seaCargoDoc.push(amsDoc)
        }
      }
      if (job.virtualHBL) {
        const cargoDocList = await new SeaExportJob(this.form).getSeaCargoDoc()
        if (cargoDocList && cargoDocList.length > 0) {
          const hawb2List = cargoDocList.filter(p => p.docType === 'HAWB2')
          if (hawb2List.length > 0) {
            seaCargoDoc.push(...hawb2List)
          }
        }
      }
      // CARGO-10762 【海运出口-海运订舱极速版】已装箱的小票，修改件毛体，未同步更新装箱件毛体
      let containerUsages = []
      if (
        this.form.lclMasterUuid &&
        (!this.form.containers || this.form.containers.length <= 0) &&
        this.form.containerUsages &&
        this.form.containerUsages.length > 0
      ) {
        containerUsages = this.form.containerUsages
      }
      return {
        job,
        seaCargoDoc,
        seaEQ: this.seaEqList,
        delseaEQUuids: this.form.delseaEQUuids,
        cargoBulkDetailList: this.cargoBulkDetailList,
        containers: this.form.containers, // this.form.containers.filter(p => p.isDirty === true), // 实际件毛体 更改影响装箱数据未标记isDirty，后续根据需要再处理
        containerUsages: containerUsages,
        delContainerUuids: this.form.delContainerUuids, // 删除的箱子uuid
        delContainerUsageUuids: this.form.delContainerUsageUuids, // 删除的装箱uuid
        surchargeTerms: this.form.surchargeTerms
      }
    },
    async validateForm() {
      const form = this.form
      if (form.customerId < 1) {
        throw new TabError(this.$t('Message.ConsignationCompanyCannotBeNull'), 'tabBuyerConsoleFclBookingMaster')
      }
      await JobUtils.checkCustomerBranchScope(form, 'tabBuyerConsoleFclBookingMaster')
      await SecurityUtil.companyisActive(this.$t('SeaExport.Customer'), form.customerId, 'tabBuyerConsoleFclBookingMaster')
      if (form.bookingAgent) {
        await SecurityUtil.companyisActive(this.$t('SeaExport.BookingAgent'), form.bookingAgent, 'tabBuyerConsoleFclBookingMaster')
      }
      if (form.destinationAgent) {
        await SecurityUtil.companyisActive(this.$t('SeaExport.DestinationAgent'), form.destinationAgent, 'tabBuyerConsoleFclBookingMaster', 'englishName')
      }
      if (form.cargoSource === CargoSource.NC_CARGO_SOURCE.code && form.designationAgent) {
        await SecurityUtil.companyisActive(this.$t('SeaExport.NominatedAgent'), form.designationAgent, 'tabBuyerConsoleFclBookingMaster', 'englishName')
      }
      if (form.customsBroker) {
        await SecurityUtil.companyisActive(this.$t('SeaExport.CustomsBroker'), form.customsBroker, 'tabBuyerConsoleFclBookingMaster')
      }
      if (form.warehouseCmp) {
        await SecurityUtil.companyisActive(this.$t('SeaExport.Warehouse'), form.warehouseCmp, 'tabBuyerConsoleFclBookingMaster')
      }
      if (form.carryingCmp) {
        await SecurityUtil.companyisActive(this.$t('SeaExport.HaulageCompany'), form.carryingCmp, 'tabBuyerConsoleFclBookingMaster')
      }
      if (form.carrierId) {
        await SecurityUtil.companyisActive(this.$t('SeaExport.ShippingCompany'), form.carrierId, 'tabBuyerConsoleFclBookingMaster')
      }
      if (form.carrierAgentId) {
        await SecurityUtil.companyisActive(this.$t('SeaExport.CarrierAgent'), form.carrierAgentId, 'tabBuyerConsoleFclBookingMaster')
      }
      if (!form.containerLoadType) {
        throw new TabError(this.$t('Message.FLCLTypeCannotBeNull'), 'tabBuyerConsoleFclBookingMaster')
      }
      if (!form.loadingPortCode) {
        throw new TabError(this.$t('Message.POLCannotBeNull'), 'tabBuyerConsoleFclBookingMaster')
      }
      if (form.transfering && !form.transferPortCode) {
        throw new TabError(this.$t('Message.IfThereIsATransferTheTransferPortCannotBeNull'), 'tabBuyerConsoleFclBookingMaster')
      }
      if (!form.dischargingPortCode) {
        throw new TabError(this.$t('Message.PortOfDischargeCannotBeNull'), 'tabBuyerConsoleFclBookingMaster')
      }
      if (!form.destinationPortCode) {
        throw new TabError(this.$t('Message.PlaceOfDeliveryCannotBeNull'), 'tabBuyerConsoleFclBookingMaster')
      }
      if (form.cargoSource === 'SC' || parseInt(this.config.get('NorminationJobSaleType')) === 1) {
        if (!form.sales) {
          throw new TabError(this.$t('Message.SalesCannotBeNull'), 'tabBuyerConsoleFclBookingMaster')
        }
        if (!form.salesOffice) {
          throw new TabError(this.$t('Message.SalesBranchCompanyIsNullPleaseReSelectSales'), 'tabBuyerConsoleFclBookingMaster')
        }
        if (!form.salesDepartment) {
          throw new TabError(this.$t('Message.SalesDepartmentIsNullPleaseReSelectSales'), 'tabBuyerConsoleFclBookingMaster')
        }
      } else {
        if (form.sales && !form.salesDepartment) {
          throw new TabError(this.$t('Message.SalesDepartmentIsNullPleaseReSelectSales'), 'tabBuyerConsoleFclBookingMaster')
        }
      }
      if (!form.etd) {
        throw new TabError(this.$t('Message.DateOfDepartureCannotBeNull'), 'tabBuyerConsoleFclBookingMaster')
      }
      if (form.etd && form.eta && form.eta < form.etd) {
        throw new TabError(this.$t('Message.DateOfDepartureCannotBeLaterThanDateOfArrival'), 'tabBuyerConsoleFclBookingMaster')
      }
      if (form.cargoSource === 'NC' && !form.designationAgent) {
        throw new TabError(this.$t('Message.NominatedAgentCannotBeNull'), 'tabBuyerConsoleFclBookingMaster')
      }
      if (this.config.get('SERequirePONO') === '1' && !form.poNo) {
        throw new TabError(this.$t('Message.ItemNoCannotBeNull'), 'tabBuyerConsoleFclBookingMaster')
      }
      if (form.containerLoadType === 'FCL' || form.containerLoadType === 'BCF') {
        if (!this.seaEqList || this.seaEqList.length === 0) {
          throw new TabError(this.$t('Message.EQSizeCannotBeNull'), 'tabBuyerConsoleFclBookingMaster')
        }
      }
      // 判断销售是否是本人(新增订舱预审)
      if (form.jobState === -1) {
        const bookingIsOpenSaleCheck = parseInt(this.config.get('BookingIsOpenSaleCheck')) === 0
        if (form.sales !== this.$store.getters.userInfo.userId && !bookingIsOpenSaleCheck) {
          throw new TabError(this.$t('Message.DearYouCanOnlySelectYourOwnCustomers'), 'tabBuyerConsoleFclBookingMaster')
        }
      }
      if (!form.opDepartment) {
        throw new TabError(this.$t('SeaExport.OperationDepartmentCannotBeEmpty'), 'tabBuyerConsoleFclBookingMaster')
      }
      if ((form.containerLoadType === 'FCL' || form.containerLoadType === 'BB' || form.containerLoadType === 'BCF') && this.seaEqList && this.seaEqList.length > 0) {
        if (!form.seaEQ) form.seaEQ = this.seaEqList
        if (ContainerUtil.checkQuantityFromSeaEQ(form)) {
          throw new TabError(this.$t('SeaExport.CartonQuantityCannotBeZero'), 'tabBuyerConsoleFclBookingMaster')
        }
        if (ContainerUtil.checkNoDuplationSeaEQ(form)) {
          throw new TabError(this.$t('SeaExport.RepeatBoxType'), 'tabBuyerConsoleFclBookingMaster')
        }
      }
      if (!SecurityUtil.customerIsOwn(form.customerId) && !form.uuid) {
        throw new TabError(this.$t('CargoMsg.Cargo_CustomerNotOwn'), 'tabBuyerConsoleFclBookingMaster')
      }
    },
    // 组装打印参数
    getPrintData() {
      const params = {}
      // const reqKeys = this.getRequestSelectedKeys()
      // params.REQUEST_UUID = !reqKeys || reqKeys.length === 0 ? '' : reqKeys
      PrintTemplateUtil.buildPrintDataByBooking(this.form, params)
      params.category = 'BOOKING'
      params.ctx = new SeaExportJob(this.form)
      return params
    },
    // 打印回调
    printedCallback(event) {
      this.$logger.log(event)
      const template = event.template
      const documentType = event.documentType
      if (template && documentType) {
        const objParams = {
          jobUuid: this.form.uuid,
          docKeys: documentType.uuid
        }
        this.$logger.log(objParams)
        updateTrackingForDocumentType(objParams)
      }
    },
    /**
     * 客户特殊要求
     */
    getRequestSelectedKeys() {
      return this.$refs['selectedSpecialRequest'].getRequestSelectedKeys() || []
    },
    endTabHandler() {
      this.pm.fillModel()
    },
    customsBrokerFilter(item, inputVal) {
      if (item.cmpIdx === inputVal) {
        return true
      }
      return item.customsBroker && item.seaExport && item.active
    },
    wrapAddr(source, from, to, maxChars) {
      CargoDocUtil.sftAddrInputWrap.call(this, source, from, to, maxChars)
    },
    onRowDataChanged(event) {
      // 重置（多选）选中行
      this.selectedRows = []
    },
    // grid多选
    onMultipleSelected(event) {
      this.selectedRows = this.gridApi.getSelectedRows()
    },
    // 编辑小票
    btnLcLEditClickHandler() {
      if (this.selectedRow) {
        this.$emit('selectJob', this.selectedRow.uuid)
      } else {
        throw new ErrorTip(this.$t('common.tips.hasOneAtleast'))
      }
    },
    // 拼箱主票直接新增拼箱分票
    async btnCreateClickHandler() {
      const job = this.form
      if (!job.jobNo) {
        throw new ErrorTip(this.$t('Message.TheMasterBillBusinessNumberHasNotBeenGeneratedPleaseSaveTheTheMasterBillFirst'))
      }
      if (!await SecurityUtil.canOPEditWithAlert(job)) {
        return
      }
      this.ticketDialog.value = 1
      this.ticketDialog.visible = true
    },
    toAddTicket() {
      this.pm.selectWindowHandler(this.ticketDialog.value)
      this.ticketDialog.visible = false
    },
    // 加入小票
    async btnImportLclClickHandler(event) {
      if (!await SecurityUtil.canOPEditWithAlert(this.form)) {
        return
      }
      this.querySELclDialog.visible = true
    },
    // 单票删除小票
    async btnRemoveClickHandler() {
      const selectJob = this.selectedRow
      if (!selectJob) {
        throw new ErrorTip(this.$t('Message.PleaseSelectSubBills'))
      }
      if (selectJob.jobState > 0) {
        throw new ErrorTip(this.$t(`[${selectJob.jobNo}]${this.$t('Message.IsNotOperationStatus')}`))
      }
      await new SeaExportJob(selectJob).getContainerUsages()
      if (selectJob.quantityActual !== this.pm.getItemLeft(selectJob) || selectJob.weightActual !== this.pm.getWeightLeft(selectJob) ||
        selectJob.cubageActual !== this.pm.getCubageLeft(selectJob)) {
        throw new ErrorTip(this.$t('Message.TheSubBillHasBeenConsolidatedAndCannotBeDelete'))
      }
      if (selectJob.containerUsages && selectJob.containerUsages.length > 0) {
        for (const c of selectJob.containerUsages) {
          if (c.container && c.container.jobUuid && c.container.jobUuid === this.form.uuid) {
            throw new ErrorTip(this.$t('Message.TheSubBillHasBeenConsolidatedAndCannotBeDelete'))
          }
        }
      }
      const loading = getLoading()
      this.context.loading = true
      await validateDelJob({ jobKeys: [selectJob.uuid] }).then(res => {
        this.pm.validateDelJobResultHandler(res.data)
      }).finally(() => {
        loading.close()
        this.context.loading = false
      })
    },
    onCargoEnglishNameChange() {
      if (this.mblDoc) {
        this.mblDoc._cargoEnglishNameTime = new Date()
      }
    },
    onMarkChange() {
      if (this.mblDoc) {
        this.mblDoc._markTime = new Date()
      }
    },
    dragging(e) {
      document.getElementById('app').classList.add('disabled-select')
      const division = this.$refs.division
      const divisionRect = division.getBoundingClientRect()
      const slaveDiv = this.$refs.slaveDiv
      const slaveDivRect = slaveDiv.getBoundingClientRect()
      // 拖拽偏移量（向上增加高度，向下缩减高度） = 拖拽图标位置 - 鼠标位置
      const dragOffset = divisionRect.top + this.divisionHalfHeight - e.clientY
      // 新的小票区域高度
      let newHeight = slaveDivRect.height + dragOffset
      // 表格最小高度为200
      if (newHeight < 200) {
        newHeight = 200
      }
      slaveDiv.style.height = newHeight + 'px'
      // 触发竖向的滚动条滚动
      this.$emit('verticalScroll', dragOffset)
    },
    onCustomJobTypeChange() {
      JobUtils.matchUserPortConfig(this, this.form)
      JobUtils.matchRegionWarehouseMappingConfig(this.form, warehouseId => this.pm.warehouseCmpChangeHandler({ value: warehouseId }), false, null, this.context.modifiedData)
    },
    // 设置操作分公司
    setOpOffice(val) {
      this.form.opOffice = val
    },
    onCargoTypeChagne() {
      JobUtils.matchUserPortConfig(this, this.form)
    },
    // 合同规则相关字段切换时调用刷新【客户、指定货代理】信控信息
    contractRuleFieldChange(customerId, designationAgent) {
      this.pm.checkCredit()
      if (this.creditOpen) {
        // this.pm.checkCreditByCompany(customerId, 1)
        // this.pm.checkCreditByCompany(designationAgent, 2)
        this.pm.checkNewJobCreditInfo()
      }
    }
  }
}
</script>

<style scoped>
.division {
  display: inline-block;
  width: 18px;
  margin-left: calc(40%);
  padding: 1px 0;
  cursor: ns-resize;
}
.division .line {
  width: 100%;
  height: 0px;
  margin-bottom: 1px;
  border-bottom: 2px solid #bdbdbd;
}
</style>
<style lang="scss" scoped>
.form-item-label {
  .el-form-item {
    /deep/.el-form-item__label {
      width: 105px !important;
    }
    /deep/.el-form-item__content {
      margin-left: 105px !important;
    }
  }
}
.poNoClass {
  /deep/ .el-input.is-disabled .el-input__inner {
    color: red !important;
  }
}
</style>
